// Generated by tools/codegen/generate.py from docs/database. Don't edit: change the schema or spec and regenerate.
import type { ResourceDef } from '@pos/admin-ui';

export const RESOURCES = {
  "org.brand": {
    "key": "org.brand",
    "title": "md.resources.org_brand",
    "path": "/api/v1/identity/brands",
    "readPermission": "ho.org.brands.read",
    "writePermission": "ho.org.brands.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "logoUrl",
        "label": "md.fields.logo_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "settings",
        "label": "md.fields.settings",
        "required": false,
        "type": "json"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "logoUrl": null,
      "settings": "{}"
    },
    "children": [],
    "filters": [],
    "route": "/org/brands",
    "group": "org"
  },
  "org.legal_entity": {
    "key": "org.legal_entity",
    "title": "md.resources.org_legal_entity",
    "path": "/api/v1/identity/legal-entities",
    "readPermission": "ho.org.legal_entities.read",
    "writePermission": "ho.org.legal_entities.manage",
    "labelFields": [
      "code"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "legalName",
        "type": "text",
        "header": "md.fields.legal_name"
      },
      {
        "key": "taxCode",
        "type": "text",
        "header": "md.fields.tax_code"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "legalName",
        "label": "md.fields.legal_name",
        "required": true,
        "type": "text"
      },
      {
        "key": "taxCode",
        "label": "md.fields.tax_code",
        "required": true,
        "type": "text"
      },
      {
        "key": "phone",
        "label": "md.fields.phone",
        "required": false,
        "type": "text"
      },
      {
        "key": "email",
        "label": "md.fields.email",
        "required": false,
        "type": "text"
      },
      {
        "key": "countryCode",
        "label": "md.fields.country_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "provinceCode",
        "label": "md.fields.province_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "districtCode",
        "label": "md.fields.district_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "wardCode",
        "label": "md.fields.ward_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "postalCode",
        "label": "md.fields.postal_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "divisionId",
        "label": "md.fields.division_id",
        "required": false,
        "type": "text"
      },
      {
        "key": "streetAddress",
        "label": "md.fields.street_address",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "legalName": "",
      "taxCode": "",
      "phone": null,
      "email": null,
      "countryCode": null,
      "provinceCode": null,
      "districtCode": null,
      "wardCode": null,
      "postalCode": null,
      "divisionId": null,
      "streetAddress": null,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/org/legal-entities",
    "group": "org",
    "address": {
      "country": "countryCode",
      "province": "provinceCode",
      "district": "districtCode",
      "ward": "wardCode",
      "postal": "postalCode",
      "street": "streetAddress",
      "division": "divisionId"
    }
  },
  "org.store": {
    "key": "org.store",
    "title": "md.resources.org_store",
    "path": "/api/v1/identity/stores",
    "readPermission": "ho.org.stores.read",
    "writePermission": "ho.org.stores.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "dayCloseOpenOrders",
        "type": "select",
        "options": [
          {
            "value": "block",
            "label": "md.enums.day_close_open_orders.block"
          },
          {
            "value": "carry_over",
            "label": "md.enums.day_close_open_orders.carry_over"
          }
        ],
        "header": "md.fields.day_close_open_orders"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "setup",
            "label": "md.enums.status.setup"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "legalEntityId",
        "type": "reference",
        "ref": "org.legal_entity",
        "header": "md.fields.legal_entity_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "legalEntityId",
        "label": "md.fields.legal_entity_id",
        "required": false,
        "type": "reference",
        "ref": "org.legal_entity"
      },
      {
        "key": "legalName",
        "label": "md.fields.legal_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "taxCode",
        "label": "md.fields.tax_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "phone",
        "label": "md.fields.phone",
        "required": false,
        "type": "text"
      },
      {
        "key": "countryCode",
        "label": "md.fields.country_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "provinceCode",
        "label": "md.fields.province_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "districtCode",
        "label": "md.fields.district_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "wardCode",
        "label": "md.fields.ward_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "postalCode",
        "label": "md.fields.postal_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "divisionId",
        "label": "md.fields.division_id",
        "required": false,
        "type": "text"
      },
      {
        "key": "streetAddress",
        "label": "md.fields.street_address",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "latitude",
        "label": "md.fields.latitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "longitude",
        "label": "md.fields.longitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "timeZone",
        "label": "md.fields.time_zone",
        "required": false,
        "type": "text"
      },
      {
        "key": "locale",
        "label": "md.fields.locale",
        "required": false,
        "type": "text"
      },
      {
        "key": "currencyCode",
        "label": "md.fields.currency_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "dayCutoffAt",
        "label": "md.fields.day_cutoff_at",
        "required": false,
        "type": "time"
      },
      {
        "key": "dayCloseOpenOrders",
        "label": "md.fields.day_close_open_orders",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "block",
            "label": "md.enums.day_close_open_orders.block"
          },
          {
            "value": "carry_over",
            "label": "md.enums.day_close_open_orders.carry_over"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "setup",
            "label": "md.enums.status.setup"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      },
      {
        "key": "openedOn",
        "label": "md.fields.opened_on",
        "required": false,
        "type": "date"
      },
      {
        "key": "settings",
        "label": "md.fields.settings",
        "required": false,
        "type": "json"
      },
      {
        "key": "slug",
        "label": "md.fields.slug",
        "required": false,
        "type": "text"
      },
      {
        "key": "email",
        "label": "md.fields.email",
        "required": false,
        "type": "text"
      },
      {
        "key": "mapsUrl",
        "label": "md.fields.maps_url",
        "required": false,
        "type": "text"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "legalEntityId": null,
      "legalName": null,
      "taxCode": null,
      "phone": null,
      "countryCode": null,
      "provinceCode": null,
      "districtCode": null,
      "wardCode": null,
      "postalCode": null,
      "divisionId": null,
      "streetAddress": null,
      "latitude": null,
      "longitude": null,
      "timeZone": "Asia/Ho_Chi_Minh",
      "locale": "vi-VN",
      "currencyCode": "VND",
      "dayCutoffAt": null,
      "dayCloseOpenOrders": "block",
      "status": "active",
      "openedOn": null,
      "settings": "{}",
      "slug": null,
      "email": null,
      "mapsUrl": null
    },
    "children": [
      "org.store_opening_hours"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "legalEntityId",
        "label": "md.fields.legal_entity_id",
        "type": "reference",
        "ref": "org.legal_entity"
      },
      {
        "key": "dayCloseOpenOrders",
        "label": "md.fields.day_close_open_orders",
        "type": "select",
        "options": [
          {
            "value": "block",
            "label": "md.enums.day_close_open_orders.block"
          },
          {
            "value": "carry_over",
            "label": "md.enums.day_close_open_orders.carry_over"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "setup",
            "label": "md.enums.status.setup"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      },
      {
        "key": "openedOn",
        "label": "md.fields.opened_on",
        "type": "date"
      }
    ],
    "route": "/org/stores",
    "group": "org",
    "address": {
      "country": "countryCode",
      "province": "provinceCode",
      "district": "districtCode",
      "ward": "wardCode",
      "postal": "postalCode",
      "street": "streetAddress",
      "division": "divisionId"
    }
  },
  "org.store_opening_hours": {
    "key": "org.store_opening_hours",
    "title": "md.resources.org_store_opening_hours",
    "path": "/api/v1/identity/stores/{parentId}/opening-hours",
    "readPermission": "ho.org.stores.read",
    "writePermission": "ho.org.stores.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "dayOfWeek",
        "type": "select",
        "options": [
          {
            "value": 1,
            "label": "md.enums.day_of_week.1"
          },
          {
            "value": 2,
            "label": "md.enums.day_of_week.2"
          },
          {
            "value": 3,
            "label": "md.enums.day_of_week.3"
          },
          {
            "value": 4,
            "label": "md.enums.day_of_week.4"
          },
          {
            "value": 5,
            "label": "md.enums.day_of_week.5"
          },
          {
            "value": 6,
            "label": "md.enums.day_of_week.6"
          },
          {
            "value": 7,
            "label": "md.enums.day_of_week.7"
          }
        ],
        "header": "md.fields.day_of_week"
      },
      {
        "key": "opensAt",
        "type": "time",
        "header": "md.fields.opens_at"
      },
      {
        "key": "closesAt",
        "type": "time",
        "header": "md.fields.closes_at"
      }
    ],
    "fields": [
      {
        "key": "dayOfWeek",
        "label": "md.fields.day_of_week",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": 1,
            "label": "md.enums.day_of_week.1"
          },
          {
            "value": 2,
            "label": "md.enums.day_of_week.2"
          },
          {
            "value": 3,
            "label": "md.enums.day_of_week.3"
          },
          {
            "value": 4,
            "label": "md.enums.day_of_week.4"
          },
          {
            "value": 5,
            "label": "md.enums.day_of_week.5"
          },
          {
            "value": 6,
            "label": "md.enums.day_of_week.6"
          },
          {
            "value": 7,
            "label": "md.enums.day_of_week.7"
          }
        ]
      },
      {
        "key": "opensAt",
        "label": "md.fields.opens_at",
        "required": true,
        "type": "time"
      },
      {
        "key": "closesAt",
        "label": "md.fields.closes_at",
        "required": true,
        "type": "time"
      }
    ],
    "empty": {
      "dayOfWeek": null,
      "opensAt": null,
      "closesAt": null
    },
    "children": [],
    "filters": [],
    "parent": "org.store"
  },
  "org.store_group": {
    "key": "org.store_group",
    "title": "md.resources.org_store_group",
    "path": "/api/v1/identity/store-groups",
    "readPermission": "ho.org.store_groups.read",
    "writePermission": "ho.org.store_groups.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": ""
    },
    "children": [
      "org.store_group_member"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      }
    ],
    "route": "/org/store-groups",
    "group": "org",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "org.store_group_member": {
    "key": "org.store_group_member",
    "title": "md.resources.org_store_group_member",
    "path": "/api/v1/identity/store-groups/{parentId}/stores",
    "readPermission": "ho.org.store_groups.read",
    "writePermission": "ho.org.store_groups.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "empty": {
      "storeId": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "parent": "org.store_group",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "org.app_user": {
    "key": "org.app_user",
    "title": "md.resources.org_app_user",
    "path": "/api/v1/identity/staff",
    "readPermission": "ho.org.staff.read",
    "writePermission": "ho.org.staff.manage",
    "labelFields": [
      "display_name",
      "staff_code"
    ],
    "columns": [
      {
        "key": "staffCode",
        "type": "text",
        "header": "md.fields.staff_code"
      },
      {
        "key": "displayName",
        "type": "text",
        "header": "md.fields.display_name"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "locked",
            "label": "md.enums.status.locked"
          },
          {
            "value": "disabled",
            "label": "md.enums.status.disabled"
          }
        ],
        "header": "md.fields.status"
      }
    ],
    "fields": [
      {
        "key": "staffCode",
        "label": "md.fields.staff_code",
        "required": true,
        "type": "text"
      },
      {
        "key": "displayName",
        "label": "md.fields.display_name",
        "required": true,
        "type": "text"
      },
      {
        "key": "email",
        "label": "md.fields.email",
        "required": false,
        "type": "text"
      },
      {
        "key": "phone",
        "label": "md.fields.phone",
        "required": false,
        "type": "text"
      },
      {
        "key": "preferredLanguage",
        "label": "md.fields.preferred_language",
        "required": false,
        "type": "text"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "locked",
            "label": "md.enums.status.locked"
          },
          {
            "value": "disabled",
            "label": "md.enums.status.disabled"
          }
        ]
      }
    ],
    "empty": {
      "staffCode": "",
      "displayName": "",
      "email": null,
      "phone": null,
      "preferredLanguage": "vi",
      "status": "active"
    },
    "children": [
      "org.user_store_role"
    ],
    "filters": [
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "locked",
            "label": "md.enums.status.locked"
          },
          {
            "value": "disabled",
            "label": "md.enums.status.disabled"
          }
        ]
      }
    ],
    "route": "/org/staff",
    "group": "org"
  },
  "org.user_store_role": {
    "key": "org.user_store_role",
    "title": "md.resources.org_user_store_role",
    "path": "/api/v1/identity/staff/{parentId}/roles",
    "readPermission": "ho.org.staff.read",
    "writePermission": "ho.org.staff.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "roleId",
        "type": "reference",
        "ref": "org.role",
        "header": "md.fields.role_id"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "roleId",
        "label": "md.fields.role_id",
        "required": true,
        "type": "reference",
        "ref": "org.role"
      },
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "required": false,
        "type": "reference",
        "ref": "org.store_group"
      }
    ],
    "empty": {
      "roleId": null,
      "brandId": null,
      "storeId": null,
      "storeGroupId": null
    },
    "children": [],
    "filters": [
      {
        "key": "roleId",
        "label": "md.fields.role_id",
        "type": "reference",
        "ref": "org.role"
      },
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "type": "reference",
        "ref": "org.store_group"
      }
    ],
    "parent": "org.app_user",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "org.role": {
    "key": "org.role",
    "title": "md.resources.org_role",
    "path": "/api/v1/identity/roles",
    "readPermission": "ho.org.roles.read",
    "writePermission": "ho.org.roles.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "limits",
        "label": "md.fields.limits",
        "required": false,
        "type": "json"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "limits": "{}"
    },
    "children": [
      "org.role_permission"
    ],
    "filters": [
      {
        "key": "isSystem",
        "label": "md.fields.is_system",
        "type": "toggle"
      }
    ],
    "route": "/org/roles",
    "group": "org"
  },
  "org.role_permission": {
    "key": "org.role_permission",
    "title": "md.resources.org_role_permission",
    "path": "/api/v1/identity/roles/{parentId}/permissions",
    "readPermission": "ho.org.roles.read",
    "writePermission": "ho.org.roles.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "permissionCode",
        "type": "reference",
        "ref": "org.permission",
        "header": "md.fields.permission_code"
      }
    ],
    "fields": [
      {
        "key": "permissionCode",
        "label": "md.fields.permission_code",
        "required": true,
        "type": "reference",
        "ref": "org.permission"
      }
    ],
    "empty": {
      "permissionCode": ""
    },
    "children": [],
    "filters": [
      {
        "key": "permissionCode",
        "label": "md.fields.permission_code",
        "type": "reference",
        "ref": "org.permission"
      }
    ],
    "parent": "org.role"
  },
  "geo.country": {
    "key": "geo.country",
    "title": "md.resources.geo_country",
    "path": "/api/v1/locations/countries",
    "readPermission": "ho.locations.countries.read",
    "writePermission": "ho.locations.countries.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "code3",
        "label": "md.fields.code3",
        "required": false,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "phoneCode",
        "label": "md.fields.phone_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "currencyCode",
        "label": "md.fields.currency_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "postalCodePattern",
        "label": "md.fields.postal_code_pattern",
        "required": false,
        "type": "text"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "code3": null,
      "name": "",
      "nameI18n": {},
      "phoneCode": null,
      "currencyCode": null,
      "postalCodePattern": null,
      "sortOrder": 0,
      "isActive": true
    },
    "children": [
      "geo.admin_level",
      "geo.admin_unit_type",
      "geo.region"
    ],
    "filters": [
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/geo/countries",
    "group": "geo"
  },
  "geo.admin_level": {
    "key": "geo.admin_level",
    "title": "md.resources.geo_admin_level",
    "path": "/api/v1/locations/countries/{parentId}/levels",
    "readPermission": "ho.locations.countries.read",
    "writePermission": "ho.locations.countries.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "level",
        "label": "md.fields.level",
        "required": true,
        "type": "number"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "isRequired",
        "label": "md.fields.is_required",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "level": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "isRequired": true,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "isRequired",
        "label": "md.fields.is_required",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "parent": "geo.country"
  },
  "geo.admin_unit_type": {
    "key": "geo.admin_unit_type",
    "title": "md.resources.geo_admin_unit_type",
    "path": "/api/v1/locations/countries/{parentId}/unit-types",
    "readPermission": "ho.locations.countries.read",
    "writePermission": "ho.locations.countries.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "shortName",
        "label": "md.fields.short_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "shortNameI18n",
        "label": "md.fields.short_name_i18n",
        "required": false,
        "type": "localized"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "nameI18n": {},
      "shortName": null,
      "shortNameI18n": {}
    },
    "children": [],
    "filters": [],
    "parent": "geo.country"
  },
  "geo.region": {
    "key": "geo.region",
    "title": "md.resources.geo_region",
    "path": "/api/v1/locations/countries/{parentId}/regions",
    "readPermission": "ho.locations.countries.read",
    "writePermission": "ho.locations.countries.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "nameI18n": {}
    },
    "children": [],
    "filters": [],
    "parent": "geo.country"
  },
  "geo.admin_division": {
    "key": "geo.admin_division",
    "title": "md.resources.geo_admin_division",
    "path": "/api/v1/locations/divisions",
    "readPermission": "ho.locations.divisions.read",
    "writePermission": "ho.locations.divisions.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "countryId",
        "type": "reference",
        "ref": "geo.country",
        "header": "md.fields.country_id"
      },
      {
        "key": "parentId",
        "type": "reference",
        "ref": "geo.admin_division",
        "header": "md.fields.parent_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "countryId",
        "label": "md.fields.country_id",
        "required": true,
        "type": "reference",
        "ref": "geo.country"
      },
      {
        "key": "level",
        "label": "md.fields.level",
        "required": true,
        "type": "number"
      },
      {
        "key": "parentId",
        "label": "md.fields.parent_id",
        "required": false,
        "type": "reference",
        "ref": "geo.admin_division"
      },
      {
        "key": "unitTypeId",
        "label": "md.fields.unit_type_id",
        "required": false,
        "type": "reference",
        "ref": "geo.admin_unit_type"
      },
      {
        "key": "regionId",
        "label": "md.fields.region_id",
        "required": false,
        "type": "reference",
        "ref": "geo.region"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "fullName",
        "label": "md.fields.full_name",
        "required": true,
        "type": "text"
      },
      {
        "key": "fullNameI18n",
        "label": "md.fields.full_name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "slug",
        "label": "md.fields.slug",
        "required": false,
        "type": "text"
      },
      {
        "key": "latitude",
        "label": "md.fields.latitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "longitude",
        "label": "md.fields.longitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "date"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "source",
        "label": "md.fields.source",
        "required": false,
        "type": "text"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "countryId": null,
      "level": null,
      "parentId": null,
      "unitTypeId": null,
      "regionId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "fullName": "",
      "fullNameI18n": {},
      "slug": null,
      "latitude": null,
      "longitude": null,
      "validFrom": null,
      "validTo": null,
      "isActive": true,
      "source": null,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "countryId",
        "label": "md.fields.country_id",
        "type": "reference",
        "ref": "geo.country"
      },
      {
        "key": "parentId",
        "label": "md.fields.parent_id",
        "type": "reference",
        "ref": "geo.admin_division"
      },
      {
        "key": "unitTypeId",
        "label": "md.fields.unit_type_id",
        "type": "reference",
        "ref": "geo.admin_unit_type"
      },
      {
        "key": "regionId",
        "label": "md.fields.region_id",
        "type": "reference",
        "ref": "geo.region"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "date"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/geo/divisions",
    "group": "geo"
  },
  "geo.postal_code": {
    "key": "geo.postal_code",
    "title": "md.resources.geo_postal_code",
    "path": "/api/v1/locations/postal-codes",
    "readPermission": "ho.locations.postal_codes.read",
    "writePermission": "ho.locations.postal_codes.manage",
    "labelFields": [
      "code"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "countryId",
        "type": "reference",
        "ref": "geo.country",
        "header": "md.fields.country_id"
      },
      {
        "key": "divisionId",
        "type": "reference",
        "ref": "geo.admin_division",
        "header": "md.fields.division_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "countryId",
        "label": "md.fields.country_id",
        "required": true,
        "type": "reference",
        "ref": "geo.country"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "divisionId",
        "label": "md.fields.division_id",
        "required": false,
        "type": "reference",
        "ref": "geo.admin_division"
      },
      {
        "key": "placeName",
        "label": "md.fields.place_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "latitude",
        "label": "md.fields.latitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "longitude",
        "label": "md.fields.longitude",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "countryId": null,
      "code": "",
      "divisionId": null,
      "placeName": null,
      "latitude": null,
      "longitude": null,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "countryId",
        "label": "md.fields.country_id",
        "type": "reference",
        "ref": "geo.country"
      },
      {
        "key": "divisionId",
        "label": "md.fields.division_id",
        "type": "reference",
        "ref": "geo.admin_division"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/geo/postal-codes",
    "group": "geo"
  },
  "catalog.item": {
    "key": "catalog.item",
    "title": "md.resources.catalog_item",
    "path": "/api/v1/catalog/items",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "itemType",
        "type": "select",
        "options": [
          {
            "value": "sellable",
            "label": "md.enums.item_type.sellable"
          },
          {
            "value": "modifier_only",
            "label": "md.enums.item_type.modifier_only"
          },
          {
            "value": "ingredient",
            "label": "md.enums.item_type.ingredient"
          }
        ],
        "header": "md.fields.item_type"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "taxCategoryId",
        "type": "reference",
        "ref": "catalog.tax_category",
        "header": "md.fields.tax_category_id"
      },
      {
        "key": "price",
        "type": "decimal",
        "header": "md.fields.price"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "kitchenName",
        "label": "md.fields.kitchen_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "description",
        "label": "md.fields.description",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "descriptionI18n",
        "label": "md.fields.description_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "itemType",
        "label": "md.fields.item_type",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "sellable",
            "label": "md.enums.item_type.sellable"
          },
          {
            "value": "modifier_only",
            "label": "md.enums.item_type.modifier_only"
          },
          {
            "value": "ingredient",
            "label": "md.enums.item_type.ingredient"
          }
        ]
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "baseUomId",
        "label": "md.fields.base_uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "price",
        "label": "md.fields.price",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "isStockTracked",
        "label": "md.fields.is_stock_tracked",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "isOpenPrice",
        "label": "md.fields.is_open_price",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "imageUrl",
        "label": "md.fields.image_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "kitchenName": null,
      "description": null,
      "descriptionI18n": {},
      "itemType": "sellable",
      "taxCategoryId": null,
      "baseUomId": null,
      "price": null,
      "isStockTracked": false,
      "isOpenPrice": false,
      "imageUrl": null,
      "isActive": true
    },
    "children": [
      "catalog.item_uom",
      "catalog.item_barcode",
      "catalog.item_category_map",
      "catalog.item_modifier_group",
      "catalog.recipe",
      "catalog.store_recipe",
      "catalog.item_cost"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "itemType",
        "label": "md.fields.item_type",
        "type": "select",
        "options": [
          {
            "value": "sellable",
            "label": "md.enums.item_type.sellable"
          },
          {
            "value": "modifier_only",
            "label": "md.enums.item_type.modifier_only"
          },
          {
            "value": "ingredient",
            "label": "md.enums.item_type.ingredient"
          }
        ]
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "baseUomId",
        "label": "md.fields.base_uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isStockTracked",
        "label": "md.fields.is_stock_tracked",
        "type": "toggle"
      },
      {
        "key": "isOpenPrice",
        "label": "md.fields.is_open_price",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/catalog/items",
    "group": "catalog",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "catalog.item_uom": {
    "key": "catalog.item_uom",
    "title": "md.resources.catalog_item_uom",
    "path": "/api/v1/catalog/items/{parentId}/units",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "factorToBase",
        "label": "md.fields.factor_to_base",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "isBase",
        "label": "md.fields.is_base",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "isDefaultSale",
        "label": "md.fields.is_default_sale",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "uomId": null,
      "factorToBase": null,
      "isBase": false,
      "isDefaultSale": false,
      "sortOrder": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isBase",
        "label": "md.fields.is_base",
        "type": "toggle"
      },
      {
        "key": "isDefaultSale",
        "label": "md.fields.is_default_sale",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "parent": "catalog.item",
    "lookupPath": "/api/v1/catalog/item-units"
  },
  "catalog.item_group": {
    "key": "catalog.item_group",
    "title": "md.resources.catalog_item_group",
    "path": "/api/v1/catalog/item-groups",
    "readPermission": "ho.catalog.item_groups.read",
    "writePermission": "ho.catalog.item_groups.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "descriptionI18n",
        "label": "md.fields.description_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "slug",
        "label": "md.fields.slug",
        "required": true,
        "type": "text"
      },
      {
        "key": "imageUrl",
        "label": "md.fields.image_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "descriptionI18n": {},
      "slug": "",
      "imageUrl": null,
      "sortOrder": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/catalog/item-groups",
    "group": "catalog",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "catalog.item_barcode": {
    "key": "catalog.item_barcode",
    "title": "md.resources.catalog_item_barcode",
    "path": "/api/v1/catalog/items/{parentId}/barcodes",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "barcode"
    ],
    "columns": [
      {
        "key": "barcode",
        "type": "text",
        "header": "md.fields.barcode"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "quantity",
        "type": "decimal",
        "header": "md.fields.quantity"
      }
    ],
    "fields": [
      {
        "key": "barcode",
        "label": "md.fields.barcode",
        "required": true,
        "type": "text"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": false,
        "type": "decimal"
      }
    ],
    "empty": {
      "barcode": "",
      "uomId": null,
      "quantity": 1.0
    },
    "children": [],
    "filters": [
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      }
    ],
    "parent": "catalog.item"
  },
  "catalog.item_category_map": {
    "key": "catalog.item_category_map",
    "title": "md.resources.catalog_item_category_map",
    "path": "/api/v1/catalog/items/{parentId}/categories",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "categoryId",
        "type": "reference",
        "ref": "catalog.item_category",
        "header": "md.fields.category_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "categoryId",
        "label": "md.fields.category_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "isPrimary",
        "label": "md.fields.is_primary",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "categoryId": null,
      "isPrimary": false,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "categoryId",
        "label": "md.fields.category_id",
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "isPrimary",
        "label": "md.fields.is_primary",
        "type": "toggle"
      }
    ],
    "parent": "catalog.item"
  },
  "catalog.item_modifier_group": {
    "key": "catalog.item_modifier_group",
    "title": "md.resources.catalog_item_modifier_group",
    "path": "/api/v1/catalog/items/{parentId}/modifier-groups",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "modifierGroupId",
        "type": "reference",
        "ref": "catalog.modifier_group",
        "header": "md.fields.modifier_group_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "modifierGroupId",
        "label": "md.fields.modifier_group_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.modifier_group"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "minSelectOverride",
        "label": "md.fields.min_select_override",
        "required": false,
        "type": "number"
      },
      {
        "key": "maxSelectOverride",
        "label": "md.fields.max_select_override",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "modifierGroupId": null,
      "sortOrder": 0,
      "minSelectOverride": null,
      "maxSelectOverride": null
    },
    "children": [],
    "filters": [
      {
        "key": "modifierGroupId",
        "label": "md.fields.modifier_group_id",
        "type": "reference",
        "ref": "catalog.modifier_group"
      }
    ],
    "parent": "catalog.item"
  },
  "catalog.recipe": {
    "key": "catalog.recipe",
    "title": "md.resources.catalog_recipe",
    "path": "/api/v1/catalog/items/{parentId}/recipe",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "ingredientItemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.ingredient_item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "quantity",
        "type": "decimal",
        "header": "md.fields.quantity"
      }
    ],
    "fields": [
      {
        "key": "ingredientItemId",
        "label": "md.fields.ingredient_item_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "wastePercent",
        "label": "md.fields.waste_percent",
        "required": false,
        "type": "decimal"
      }
    ],
    "empty": {
      "ingredientItemId": null,
      "quantity": null,
      "uomId": null,
      "wastePercent": 0.0
    },
    "children": [],
    "filters": [
      {
        "key": "ingredientItemId",
        "label": "md.fields.ingredient_item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      }
    ],
    "parent": "catalog.item"
  },
  "catalog.store_recipe": {
    "key": "catalog.store_recipe",
    "title": "md.resources.catalog_store_recipe",
    "path": "/api/v1/catalog/items/{parentId}/store-recipes",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "ingredientItemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.ingredient_item_id"
      },
      {
        "key": "quantity",
        "type": "decimal",
        "header": "md.fields.quantity"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "wastePercent",
        "type": "decimal",
        "header": "md.fields.waste_percent"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "ingredientItemId",
        "label": "md.fields.ingredient_item_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "wastePercent",
        "label": "md.fields.waste_percent",
        "required": false,
        "type": "decimal"
      }
    ],
    "empty": {
      "storeId": null,
      "ingredientItemId": null,
      "quantity": null,
      "uomId": null,
      "wastePercent": 0.0
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "ingredientItemId",
        "label": "md.fields.ingredient_item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      }
    ],
    "parent": "catalog.item",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "catalog.item_cost": {
    "key": "catalog.item_cost",
    "title": "md.resources.catalog_item_cost",
    "path": "/api/v1/catalog/items/{parentId}/costs",
    "readPermission": "ho.catalog.items.read",
    "writePermission": "ho.catalog.items.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "standardCost",
        "type": "decimal",
        "header": "md.fields.standard_cost"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "standardCost",
        "label": "md.fields.standard_cost",
        "required": true,
        "type": "decimal"
      }
    ],
    "empty": {
      "storeId": null,
      "standardCost": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "parent": "catalog.item",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "catalog.item_category": {
    "key": "catalog.item_category",
    "title": "md.resources.catalog_item_category",
    "path": "/api/v1/catalog/categories",
    "readPermission": "ho.catalog.categories.read",
    "writePermission": "ho.catalog.categories.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "parentId",
        "type": "reference",
        "ref": "catalog.item_category",
        "header": "md.fields.parent_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "parentId",
        "label": "md.fields.parent_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "parentId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "parentId",
        "label": "md.fields.parent_id",
        "type": "reference",
        "ref": "catalog.item_category"
      }
    ],
    "route": "/catalog/categories",
    "group": "catalog",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "catalog.modifier_group": {
    "key": "catalog.modifier_group",
    "title": "md.resources.catalog_modifier_group",
    "path": "/api/v1/catalog/modifier-groups",
    "readPermission": "ho.catalog.modifier_groups.read",
    "writePermission": "ho.catalog.modifier_groups.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "promptText",
        "label": "md.fields.prompt_text",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "minSelect",
        "label": "md.fields.min_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "maxSelect",
        "label": "md.fields.max_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "allowQuantity",
        "label": "md.fields.allow_quantity",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "promptText": null,
      "minSelect": 0,
      "maxSelect": null,
      "allowQuantity": false,
      "sortOrder": 0
    },
    "children": [
      "catalog.modifier"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "allowQuantity",
        "label": "md.fields.allow_quantity",
        "type": "toggle"
      }
    ],
    "route": "/catalog/modifier-groups",
    "group": "catalog",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "catalog.modifier": {
    "key": "catalog.modifier",
    "title": "md.resources.catalog_modifier",
    "path": "/api/v1/catalog/modifier-groups/{parentId}/options",
    "readPermission": "ho.catalog.modifier_groups.read",
    "writePermission": "ho.catalog.modifier_groups.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "itemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "isDefault",
        "type": "toggle",
        "header": "md.fields.is_default"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "maxQuantity",
        "label": "md.fields.max_quantity",
        "required": false,
        "type": "number"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "itemId": null,
      "uomId": null,
      "isDefault": false,
      "maxQuantity": null,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "type": "toggle"
      }
    ],
    "parent": "catalog.modifier_group",
    "lookupPath": "/api/v1/catalog/modifiers"
  },
  "catalog.deal": {
    "key": "catalog.deal",
    "title": "md.resources.catalog_deal",
    "path": "/api/v1/catalog/deals",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "pricingMethod",
        "type": "select",
        "options": [
          {
            "value": "fixed",
            "label": "md.enums.pricing_method.fixed"
          },
          {
            "value": "sum_of_components",
            "label": "md.enums.pricing_method.sum_of_components"
          },
          {
            "value": "sum_minus_percent",
            "label": "md.enums.pricing_method.sum_minus_percent"
          },
          {
            "value": "sum_minus_amount",
            "label": "md.enums.pricing_method.sum_minus_amount"
          },
          {
            "value": "sum_minus_cheapest",
            "label": "md.enums.pricing_method.sum_minus_cheapest"
          }
        ],
        "header": "md.fields.pricing_method"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "taxCategoryId",
        "type": "reference",
        "ref": "catalog.tax_category",
        "header": "md.fields.tax_category_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "description",
        "label": "md.fields.description",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "descriptionI18n",
        "label": "md.fields.description_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "pricingMethod",
        "label": "md.fields.pricing_method",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "fixed",
            "label": "md.enums.pricing_method.fixed"
          },
          {
            "value": "sum_of_components",
            "label": "md.enums.pricing_method.sum_of_components"
          },
          {
            "value": "sum_minus_percent",
            "label": "md.enums.pricing_method.sum_minus_percent"
          },
          {
            "value": "sum_minus_amount",
            "label": "md.enums.pricing_method.sum_minus_amount"
          },
          {
            "value": "sum_minus_cheapest",
            "label": "md.enums.pricing_method.sum_minus_cheapest"
          }
        ]
      },
      {
        "key": "discountValue",
        "label": "md.fields.discount_value",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "excludesPromotions",
        "label": "md.fields.excludes_promotions",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "excludesRedemptions",
        "label": "md.fields.excludes_redemptions",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "description": null,
      "descriptionI18n": {},
      "pricingMethod": "",
      "discountValue": null,
      "excludesPromotions": false,
      "excludesRedemptions": false,
      "taxCategoryId": null,
      "uomId": null,
      "isActive": true
    },
    "children": [
      "catalog.deal_cost",
      "catalog.deal_component",
      "catalog.deal_availability",
      "catalog.deal_rule"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "pricingMethod",
        "label": "md.fields.pricing_method",
        "type": "select",
        "options": [
          {
            "value": "fixed",
            "label": "md.enums.pricing_method.fixed"
          },
          {
            "value": "sum_of_components",
            "label": "md.enums.pricing_method.sum_of_components"
          },
          {
            "value": "sum_minus_percent",
            "label": "md.enums.pricing_method.sum_minus_percent"
          },
          {
            "value": "sum_minus_amount",
            "label": "md.enums.pricing_method.sum_minus_amount"
          },
          {
            "value": "sum_minus_cheapest",
            "label": "md.enums.pricing_method.sum_minus_cheapest"
          }
        ]
      },
      {
        "key": "excludesPromotions",
        "label": "md.fields.excludes_promotions",
        "type": "toggle"
      },
      {
        "key": "excludesRedemptions",
        "label": "md.fields.excludes_redemptions",
        "type": "toggle"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/catalog/deals",
    "group": "catalog",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "catalog.deal_cost": {
    "key": "catalog.deal_cost",
    "title": "md.resources.catalog_deal_cost",
    "path": "/api/v1/catalog/deals/{parentId}/costs",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "standardCost",
        "type": "decimal",
        "header": "md.fields.standard_cost"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "standardCost",
        "label": "md.fields.standard_cost",
        "required": true,
        "type": "decimal"
      }
    ],
    "empty": {
      "storeId": null,
      "standardCost": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "parent": "catalog.deal",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "catalog.deal_component": {
    "key": "catalog.deal_component",
    "title": "md.resources.catalog_deal_component",
    "path": "/api/v1/catalog/deals/{parentId}/components",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "componentType",
        "type": "select",
        "options": [
          {
            "value": "auto",
            "label": "md.enums.component_type.auto"
          },
          {
            "value": "choice",
            "label": "md.enums.component_type.choice"
          }
        ],
        "header": "md.fields.component_type"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "componentType",
        "label": "md.fields.component_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "auto",
            "label": "md.enums.component_type.auto"
          },
          {
            "value": "choice",
            "label": "md.enums.component_type.choice"
          }
        ]
      },
      {
        "key": "minSelect",
        "label": "md.fields.min_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "maxSelect",
        "label": "md.fields.max_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "allowRepeat",
        "label": "md.fields.allow_repeat",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "allowItemModifiers",
        "label": "md.fields.allow_item_modifiers",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "name": "",
      "nameI18n": {},
      "componentType": "",
      "minSelect": 1,
      "maxSelect": 1,
      "allowRepeat": false,
      "allowItemModifiers": true,
      "sortOrder": 0
    },
    "children": [
      "catalog.deal_component_item"
    ],
    "filters": [
      {
        "key": "componentType",
        "label": "md.fields.component_type",
        "type": "select",
        "options": [
          {
            "value": "auto",
            "label": "md.enums.component_type.auto"
          },
          {
            "value": "choice",
            "label": "md.enums.component_type.choice"
          }
        ]
      },
      {
        "key": "allowRepeat",
        "label": "md.fields.allow_repeat",
        "type": "toggle"
      },
      {
        "key": "allowItemModifiers",
        "label": "md.fields.allow_item_modifiers",
        "type": "toggle"
      }
    ],
    "parent": "catalog.deal",
    "lookupPath": "/api/v1/catalog/deal-components"
  },
  "catalog.deal_component_item": {
    "key": "catalog.deal_component_item",
    "title": "md.resources.catalog_deal_component_item",
    "path": "/api/v1/catalog/deal-components/{parentId}/items",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "itemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "upcharge",
        "type": "decimal",
        "header": "md.fields.upcharge"
      },
      {
        "key": "quantity",
        "type": "decimal",
        "header": "md.fields.quantity"
      },
      {
        "key": "isDefault",
        "type": "toggle",
        "header": "md.fields.is_default"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "upcharge",
        "label": "md.fields.upcharge",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "itemId": null,
      "uomId": null,
      "quantity": 1.0,
      "upcharge": 0.0,
      "isDefault": false,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "type": "toggle"
      }
    ],
    "parent": "catalog.deal_component"
  },
  "catalog.deal_availability": {
    "key": "catalog.deal_availability",
    "title": "md.resources.catalog_deal_availability",
    "path": "/api/v1/catalog/deals/{parentId}/availability",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": false,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "daysOfWeek",
        "label": "md.fields.days_of_week",
        "required": false,
        "type": "weekdays"
      },
      {
        "key": "startTime",
        "label": "md.fields.start_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "endTime",
        "label": "md.fields.end_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "date"
      }
    ],
    "empty": {
      "storeId": null,
      "saleTypeId": null,
      "salesChannelId": null,
      "daysOfWeek": 127,
      "startTime": null,
      "endTime": null,
      "validFrom": null,
      "validTo": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "date"
      }
    ],
    "parent": "catalog.deal",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "catalog.deal_rule": {
    "key": "catalog.deal_rule",
    "title": "md.resources.catalog_deal_rule",
    "path": "/api/v1/catalog/deals/{parentId}/rules",
    "readPermission": "ho.catalog.deals.read",
    "writePermission": "ho.catalog.deals.manage",
    "labelFields": [
      "id"
    ],
    "columns": [],
    "fields": [
      {
        "key": "ruleType",
        "label": "md.fields.rule_type",
        "required": true,
        "type": "text"
      },
      {
        "key": "rule",
        "label": "md.fields.rule",
        "required": true,
        "type": "json"
      }
    ],
    "empty": {
      "ruleType": "",
      "rule": "{}"
    },
    "children": [],
    "filters": [],
    "parent": "catalog.deal"
  },
  "catalog.tax_category": {
    "key": "catalog.tax_category",
    "title": "md.resources.catalog_tax_category",
    "path": "/api/v1/catalog/tax-categories",
    "readPermission": "ho.catalog.tax_categories.read",
    "writePermission": "ho.catalog.tax_categories.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "isDefault",
        "type": "toggle",
        "header": "md.fields.is_default"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "isDefault": false
    },
    "children": [
      "catalog.tax_rate"
    ],
    "filters": [
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "type": "toggle"
      }
    ],
    "route": "/catalog/tax-categories",
    "group": "catalog"
  },
  "catalog.tax_rate": {
    "key": "catalog.tax_rate",
    "title": "md.resources.catalog_tax_rate",
    "path": "/api/v1/catalog/tax-categories/{parentId}/rates",
    "readPermission": "ho.catalog.tax_categories.read",
    "writePermission": "ho.catalog.tax_categories.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      },
      {
        "key": "rate",
        "type": "decimal",
        "header": "md.fields.rate"
      },
      {
        "key": "effectiveFrom",
        "type": "date",
        "header": "md.fields.effective_from"
      }
    ],
    "fields": [
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "rate",
        "label": "md.fields.rate",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "effectiveFrom",
        "label": "md.fields.effective_from",
        "required": true,
        "type": "date"
      },
      {
        "key": "effectiveTo",
        "label": "md.fields.effective_to",
        "required": false,
        "type": "date"
      }
    ],
    "empty": {
      "saleTypeId": null,
      "name": "",
      "rate": null,
      "effectiveFrom": null,
      "effectiveTo": null
    },
    "children": [],
    "filters": [
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "effectiveFrom",
        "label": "md.fields.effective_from",
        "type": "date"
      },
      {
        "key": "effectiveTo",
        "label": "md.fields.effective_to",
        "type": "date"
      }
    ],
    "parent": "catalog.tax_category"
  },
  "catalog.uom": {
    "key": "catalog.uom",
    "title": "md.resources.catalog_uom",
    "path": "/api/v1/catalog/units",
    "readPermission": "ho.catalog.units.read",
    "writePermission": "ho.catalog.units.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "isDefault",
        "type": "toggle",
        "header": "md.fields.is_default"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "decimals",
        "label": "md.fields.decimals",
        "required": false,
        "type": "number"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "decimals": 0,
      "isDefault": false
    },
    "children": [],
    "filters": [
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "type": "toggle"
      }
    ],
    "route": "/catalog/units",
    "group": "catalog"
  },
  "catalog.uom_conversion": {
    "key": "catalog.uom_conversion",
    "title": "md.resources.catalog_uom_conversion",
    "path": "/api/v1/catalog/unit-conversions",
    "readPermission": "ho.catalog.unit_conversions.read",
    "writePermission": "ho.catalog.unit_conversions.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "fromUomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.from_uom_id"
      },
      {
        "key": "toUomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.to_uom_id"
      }
    ],
    "fields": [
      {
        "key": "fromUomId",
        "label": "md.fields.from_uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "toUomId",
        "label": "md.fields.to_uom_id",
        "required": true,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "factor",
        "label": "md.fields.factor",
        "required": true,
        "type": "decimal"
      }
    ],
    "empty": {
      "fromUomId": null,
      "toUomId": null,
      "factor": null
    },
    "children": [],
    "filters": [
      {
        "key": "fromUomId",
        "label": "md.fields.from_uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "toUomId",
        "label": "md.fields.to_uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      }
    ],
    "route": "/catalog/unit-conversions",
    "group": "catalog"
  },
  "menu.menu": {
    "key": "menu.menu",
    "title": "md.resources.menu_menu",
    "path": "/api/v1/menu/menus",
    "readPermission": "ho.menu.menus.read",
    "writePermission": "ho.menu.menus.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": ""
    },
    "children": [
      "menu.menu_entry",
      "menu.menu_assignment"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      }
    ],
    "route": "/menu/menus",
    "group": "menu",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "menu.menu_entry": {
    "key": "menu.menu_entry",
    "title": "md.resources.menu_menu_entry",
    "path": "/api/v1/menu/menus/{parentId}/entries",
    "readPermission": "ho.menu.menus.read",
    "writePermission": "ho.menu.menus.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "itemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "displayCategoryId",
        "label": "md.fields.display_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isVisible",
        "label": "md.fields.is_visible",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "itemId": null,
      "uomId": null,
      "dealId": null,
      "displayCategoryId": null,
      "sortOrder": 0,
      "isVisible": true
    },
    "children": [],
    "filters": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "displayCategoryId",
        "label": "md.fields.display_category_id",
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "isVisible",
        "label": "md.fields.is_visible",
        "type": "toggle"
      }
    ],
    "parent": "menu.menu"
  },
  "menu.menu_assignment": {
    "key": "menu.menu_assignment",
    "title": "md.resources.menu_menu_assignment",
    "path": "/api/v1/menu/menus/{parentId}/assignments",
    "readPermission": "ho.menu.menus.read",
    "writePermission": "ho.menu.menus.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "storeGroupId",
        "type": "reference",
        "ref": "org.store_group",
        "header": "md.fields.store_group_id"
      },
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      },
      {
        "key": "salesChannelId",
        "type": "reference",
        "ref": "config.sales_channel",
        "header": "md.fields.sales_channel_id"
      },
      {
        "key": "daysOfWeek",
        "type": "weekdays",
        "header": "md.fields.days_of_week"
      },
      {
        "key": "startTime",
        "type": "time",
        "header": "md.fields.start_time"
      },
      {
        "key": "endTime",
        "type": "time",
        "header": "md.fields.end_time"
      },
      {
        "key": "validFrom",
        "type": "date",
        "header": "md.fields.valid_from"
      },
      {
        "key": "validTo",
        "type": "date",
        "header": "md.fields.valid_to"
      },
      {
        "key": "priority",
        "type": "number",
        "header": "md.fields.priority"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "required": false,
        "type": "reference",
        "ref": "org.store_group"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": false,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "daysOfWeek",
        "label": "md.fields.days_of_week",
        "required": false,
        "type": "weekdays"
      },
      {
        "key": "startTime",
        "label": "md.fields.start_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "endTime",
        "label": "md.fields.end_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "date"
      },
      {
        "key": "priority",
        "label": "md.fields.priority",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "storeId": null,
      "storeGroupId": null,
      "saleTypeId": null,
      "salesChannelId": null,
      "daysOfWeek": 127,
      "startTime": null,
      "endTime": null,
      "validFrom": null,
      "validTo": null,
      "priority": 0
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "type": "reference",
        "ref": "org.store_group"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "date"
      }
    ],
    "parent": "menu.menu",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "menu.menu_layout": {
    "key": "menu.menu_layout",
    "title": "md.resources.menu_menu_layout",
    "path": "/api/v1/menu/layouts",
    "readPermission": "ho.menu.layouts.read",
    "writePermission": "ho.menu.layouts.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "screenClass",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ],
        "header": "md.fields.screen_class"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "menuId",
        "type": "reference",
        "ref": "menu.menu",
        "header": "md.fields.menu_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "required": true,
        "type": "reference",
        "ref": "menu.menu"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "screenClass",
        "label": "md.fields.screen_class",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ]
      },
      {
        "key": "gridRows",
        "label": "md.fields.grid_rows",
        "required": true,
        "type": "number"
      },
      {
        "key": "gridCols",
        "label": "md.fields.grid_cols",
        "required": true,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "menuId": null,
      "code": "",
      "name": "",
      "screenClass": "",
      "gridRows": null,
      "gridCols": null
    },
    "children": [
      "menu.menu_page"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "type": "reference",
        "ref": "menu.menu"
      },
      {
        "key": "screenClass",
        "label": "md.fields.screen_class",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ]
      }
    ],
    "route": "/menu/layouts",
    "group": "menu"
  },
  "menu.menu_page": {
    "key": "menu.menu_page",
    "title": "md.resources.menu_menu_page",
    "path": "/api/v1/menu/layouts/{parentId}/pages",
    "readPermission": "ho.menu.layouts.read",
    "writePermission": "ho.menu.layouts.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "paletteKey",
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ],
        "header": "md.fields.palette_key"
      },
      {
        "key": "parentPageId",
        "type": "reference",
        "ref": "menu.menu_page",
        "header": "md.fields.parent_page_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "parentPageId",
        "label": "md.fields.parent_page_id",
        "required": false,
        "type": "reference",
        "ref": "menu.menu_page"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "paletteKey",
        "label": "md.fields.palette_key",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ]
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "parentPageId": null,
      "name": "",
      "nameI18n": {},
      "paletteKey": "neutral",
      "sortOrder": 0
    },
    "children": [
      "menu.menu_button"
    ],
    "filters": [
      {
        "key": "parentPageId",
        "label": "md.fields.parent_page_id",
        "type": "reference",
        "ref": "menu.menu_page"
      },
      {
        "key": "paletteKey",
        "label": "md.fields.palette_key",
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ]
      }
    ],
    "parent": "menu.menu_layout",
    "lookupPath": "/api/v1/menu/layout-pages"
  },
  "menu.menu_button": {
    "key": "menu.menu_button",
    "title": "md.resources.menu_menu_button",
    "path": "/api/v1/menu/layout-pages/{parentId}/buttons",
    "readPermission": "ho.menu.layouts.read",
    "writePermission": "ho.menu.layouts.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "targetType",
        "type": "select",
        "options": [
          {
            "value": "item",
            "label": "md.enums.target_type.item"
          },
          {
            "value": "deal",
            "label": "md.enums.target_type.deal"
          },
          {
            "value": "page",
            "label": "md.enums.target_type.page"
          }
        ],
        "header": "md.fields.target_type"
      },
      {
        "key": "paletteKey",
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ],
        "header": "md.fields.palette_key"
      },
      {
        "key": "itemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      }
    ],
    "fields": [
      {
        "key": "gridRow",
        "label": "md.fields.grid_row",
        "required": true,
        "type": "number"
      },
      {
        "key": "gridCol",
        "label": "md.fields.grid_col",
        "required": true,
        "type": "number"
      },
      {
        "key": "rowSpan",
        "label": "md.fields.row_span",
        "required": false,
        "type": "number"
      },
      {
        "key": "colSpan",
        "label": "md.fields.col_span",
        "required": false,
        "type": "number"
      },
      {
        "key": "targetType",
        "label": "md.fields.target_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "item",
            "label": "md.enums.target_type.item"
          },
          {
            "value": "deal",
            "label": "md.enums.target_type.deal"
          },
          {
            "value": "page",
            "label": "md.enums.target_type.page"
          }
        ]
      },
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "itemGroupId",
        "label": "md.fields.item_group_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item_group"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "targetPageId",
        "label": "md.fields.target_page_id",
        "required": false,
        "type": "reference",
        "ref": "menu.menu_page"
      },
      {
        "key": "labelOverride",
        "label": "md.fields.label_override",
        "required": false,
        "type": "text"
      },
      {
        "key": "paletteKey",
        "label": "md.fields.palette_key",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ]
      }
    ],
    "empty": {
      "gridRow": null,
      "gridCol": null,
      "rowSpan": 1,
      "colSpan": 1,
      "targetType": "",
      "itemId": null,
      "uomId": null,
      "itemGroupId": null,
      "dealId": null,
      "targetPageId": null,
      "labelOverride": null,
      "paletteKey": null
    },
    "children": [],
    "filters": [
      {
        "key": "targetType",
        "label": "md.fields.target_type",
        "type": "select",
        "options": [
          {
            "value": "item",
            "label": "md.enums.target_type.item"
          },
          {
            "value": "deal",
            "label": "md.enums.target_type.deal"
          },
          {
            "value": "page",
            "label": "md.enums.target_type.page"
          }
        ]
      },
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "itemGroupId",
        "label": "md.fields.item_group_id",
        "type": "reference",
        "ref": "catalog.item_group"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "targetPageId",
        "label": "md.fields.target_page_id",
        "type": "reference",
        "ref": "menu.menu_page"
      },
      {
        "key": "paletteKey",
        "label": "md.fields.palette_key",
        "type": "select",
        "options": [
          {
            "value": "neutral",
            "label": "md.enums.palette_key.neutral"
          },
          {
            "value": "blue",
            "label": "md.enums.palette_key.blue"
          },
          {
            "value": "cyan",
            "label": "md.enums.palette_key.cyan"
          },
          {
            "value": "teal",
            "label": "md.enums.palette_key.teal"
          },
          {
            "value": "green",
            "label": "md.enums.palette_key.green"
          },
          {
            "value": "purple",
            "label": "md.enums.palette_key.purple"
          },
          {
            "value": "magenta",
            "label": "md.enums.palette_key.magenta"
          },
          {
            "value": "red",
            "label": "md.enums.palette_key.red"
          },
          {
            "value": "warm-gray",
            "label": "md.enums.palette_key.warm-gray"
          }
        ]
      }
    ],
    "parent": "menu.menu_page"
  },
  "menu.price_list": {
    "key": "menu.price_list",
    "title": "md.resources.menu_price_list",
    "path": "/api/v1/menu/price-lists",
    "readPermission": "ho.menu.price_lists.read",
    "writePermission": "ho.menu.price_lists.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "currencyCode",
        "label": "md.fields.currency_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "isTaxInclusive",
        "label": "md.fields.is_tax_inclusive",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "currencyCode": "VND",
      "isTaxInclusive": true
    },
    "children": [
      "menu.price_list_entry",
      "menu.menu_price_list",
      "menu.price_list_assignment"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "isTaxInclusive",
        "label": "md.fields.is_tax_inclusive",
        "type": "toggle"
      }
    ],
    "route": "/menu/price-lists",
    "group": "menu",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "menu.price_list_entry": {
    "key": "menu.price_list_entry",
    "title": "md.resources.menu_price_list_entry",
    "path": "/api/v1/menu/price-lists/{parentId}/entries",
    "readPermission": "ho.menu.price_lists.read",
    "writePermission": "ho.menu.price_lists.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "itemId",
        "type": "reference",
        "ref": "catalog.item",
        "header": "md.fields.item_id"
      },
      {
        "key": "uomId",
        "type": "reference",
        "ref": "catalog.uom",
        "header": "md.fields.uom_id"
      },
      {
        "key": "price",
        "type": "decimal",
        "header": "md.fields.price"
      },
      {
        "key": "effectiveFrom",
        "type": "datetime",
        "header": "md.fields.effective_from"
      }
    ],
    "fields": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "dealComponentItemId",
        "label": "md.fields.deal_component_item_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.deal_component_item"
      },
      {
        "key": "price",
        "label": "md.fields.price",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "effectiveFrom",
        "label": "md.fields.effective_from",
        "required": true,
        "type": "datetime"
      },
      {
        "key": "effectiveTo",
        "label": "md.fields.effective_to",
        "required": false,
        "type": "datetime"
      }
    ],
    "empty": {
      "itemId": null,
      "uomId": null,
      "dealId": null,
      "dealComponentItemId": null,
      "price": null,
      "taxCategoryId": null,
      "effectiveFrom": null,
      "effectiveTo": null
    },
    "children": [],
    "filters": [
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "uomId",
        "label": "md.fields.uom_id",
        "type": "reference",
        "ref": "catalog.uom"
      },
      {
        "key": "dealId",
        "label": "md.fields.deal_id",
        "type": "reference",
        "ref": "catalog.deal"
      },
      {
        "key": "dealComponentItemId",
        "label": "md.fields.deal_component_item_id",
        "type": "reference",
        "ref": "catalog.deal_component_item"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "effectiveFrom",
        "label": "md.fields.effective_from",
        "type": "datetime"
      },
      {
        "key": "effectiveTo",
        "label": "md.fields.effective_to",
        "type": "datetime"
      }
    ],
    "parent": "menu.price_list"
  },
  "menu.menu_price_list": {
    "key": "menu.menu_price_list",
    "title": "md.resources.menu_menu_price_list",
    "path": "/api/v1/menu/price-lists/{parentId}/menus",
    "readPermission": "ho.menu.price_lists.read",
    "writePermission": "ho.menu.price_lists.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "menuId",
        "type": "reference",
        "ref": "menu.menu",
        "header": "md.fields.menu_id"
      }
    ],
    "fields": [
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "required": true,
        "type": "reference",
        "ref": "menu.menu"
      }
    ],
    "empty": {
      "menuId": null
    },
    "children": [],
    "filters": [
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "type": "reference",
        "ref": "menu.menu"
      }
    ],
    "parent": "menu.price_list"
  },
  "menu.price_list_assignment": {
    "key": "menu.price_list_assignment",
    "title": "md.resources.menu_price_list_assignment",
    "path": "/api/v1/menu/price-lists/{parentId}/assignments",
    "readPermission": "ho.menu.price_lists.read",
    "writePermission": "ho.menu.price_lists.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "storeGroupId",
        "type": "reference",
        "ref": "org.store_group",
        "header": "md.fields.store_group_id"
      },
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      },
      {
        "key": "salesChannelId",
        "type": "reference",
        "ref": "config.sales_channel",
        "header": "md.fields.sales_channel_id"
      },
      {
        "key": "daysOfWeek",
        "type": "weekdays",
        "header": "md.fields.days_of_week"
      },
      {
        "key": "startTime",
        "type": "time",
        "header": "md.fields.start_time"
      },
      {
        "key": "endTime",
        "type": "time",
        "header": "md.fields.end_time"
      },
      {
        "key": "validFrom",
        "type": "date",
        "header": "md.fields.valid_from"
      },
      {
        "key": "validTo",
        "type": "date",
        "header": "md.fields.valid_to"
      },
      {
        "key": "priority",
        "type": "number",
        "header": "md.fields.priority"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "required": false,
        "type": "reference",
        "ref": "org.store_group"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": false,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "daysOfWeek",
        "label": "md.fields.days_of_week",
        "required": false,
        "type": "weekdays"
      },
      {
        "key": "startTime",
        "label": "md.fields.start_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "endTime",
        "label": "md.fields.end_time",
        "required": false,
        "type": "time"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "date"
      },
      {
        "key": "priority",
        "label": "md.fields.priority",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "storeId": null,
      "storeGroupId": null,
      "saleTypeId": null,
      "salesChannelId": null,
      "daysOfWeek": 127,
      "startTime": null,
      "endTime": null,
      "validFrom": null,
      "validTo": null,
      "priority": 0
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "storeGroupId",
        "label": "md.fields.store_group_id",
        "type": "reference",
        "ref": "org.store_group"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "date"
      }
    ],
    "parent": "menu.price_list",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "config.sales_channel": {
    "key": "config.sales_channel",
    "title": "md.resources.config_sales_channel",
    "path": "/api/v1/menu/config/sales-channels",
    "readPermission": "ho.config.sales_channels.read",
    "writePermission": "ho.config.sales_channels.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "channelType",
        "type": "select",
        "options": [
          {
            "value": "pos",
            "label": "md.enums.channel_type.pos"
          },
          {
            "value": "website",
            "label": "md.enums.channel_type.website"
          },
          {
            "value": "app",
            "label": "md.enums.channel_type.app"
          },
          {
            "value": "zalo_mini_app",
            "label": "md.enums.channel_type.zalo_mini_app"
          },
          {
            "value": "marketplace",
            "label": "md.enums.channel_type.marketplace"
          },
          {
            "value": "api",
            "label": "md.enums.channel_type.api"
          },
          {
            "value": "qr",
            "label": "md.enums.channel_type.qr"
          }
        ],
        "header": "md.fields.channel_type"
      },
      {
        "key": "deliverySaleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.delivery_sale_type_id"
      },
      {
        "key": "pickupSaleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.pickup_sale_type_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "channelType",
        "label": "md.fields.channel_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "pos",
            "label": "md.enums.channel_type.pos"
          },
          {
            "value": "website",
            "label": "md.enums.channel_type.website"
          },
          {
            "value": "app",
            "label": "md.enums.channel_type.app"
          },
          {
            "value": "zalo_mini_app",
            "label": "md.enums.channel_type.zalo_mini_app"
          },
          {
            "value": "marketplace",
            "label": "md.enums.channel_type.marketplace"
          },
          {
            "value": "api",
            "label": "md.enums.channel_type.api"
          },
          {
            "value": "qr",
            "label": "md.enums.channel_type.qr"
          }
        ]
      },
      {
        "key": "useItemGroups",
        "label": "md.fields.use_item_groups",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "deliverySaleTypeId",
        "label": "md.fields.delivery_sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "pickupSaleTypeId",
        "label": "md.fields.pickup_sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "dineInSaleTypeId",
        "label": "md.fields.dine_in_sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "channelType": "",
      "useItemGroups": false,
      "deliverySaleTypeId": null,
      "pickupSaleTypeId": null,
      "dineInSaleTypeId": null,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "channelType",
        "label": "md.fields.channel_type",
        "type": "select",
        "options": [
          {
            "value": "pos",
            "label": "md.enums.channel_type.pos"
          },
          {
            "value": "website",
            "label": "md.enums.channel_type.website"
          },
          {
            "value": "app",
            "label": "md.enums.channel_type.app"
          },
          {
            "value": "zalo_mini_app",
            "label": "md.enums.channel_type.zalo_mini_app"
          },
          {
            "value": "marketplace",
            "label": "md.enums.channel_type.marketplace"
          },
          {
            "value": "api",
            "label": "md.enums.channel_type.api"
          },
          {
            "value": "qr",
            "label": "md.enums.channel_type.qr"
          }
        ]
      },
      {
        "key": "useItemGroups",
        "label": "md.fields.use_item_groups",
        "type": "toggle"
      },
      {
        "key": "deliverySaleTypeId",
        "label": "md.fields.delivery_sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "pickupSaleTypeId",
        "label": "md.fields.pickup_sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "dineInSaleTypeId",
        "label": "md.fields.dine_in_sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/pos/sales-channels",
    "group": "pos"
  },
  "config.sale_type": {
    "key": "config.sale_type",
    "title": "md.resources.config_sale_type",
    "path": "/api/v1/menu/config/sale-types",
    "readPermission": "ho.config.sale_types.read",
    "writePermission": "ho.config.sale_types.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "baseBehavior",
        "type": "select",
        "options": [
          {
            "value": "dine_in",
            "label": "md.enums.base_behavior.dine_in"
          },
          {
            "value": "takeaway",
            "label": "md.enums.base_behavior.takeaway"
          },
          {
            "value": "delivery",
            "label": "md.enums.base_behavior.delivery"
          },
          {
            "value": "pickup",
            "label": "md.enums.base_behavior.pickup"
          }
        ],
        "header": "md.fields.base_behavior"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "orderFlowId",
        "type": "reference",
        "ref": "config.order_flow",
        "header": "md.fields.order_flow_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "baseBehavior",
        "label": "md.fields.base_behavior",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "dine_in",
            "label": "md.enums.base_behavior.dine_in"
          },
          {
            "value": "takeaway",
            "label": "md.enums.base_behavior.takeaway"
          },
          {
            "value": "delivery",
            "label": "md.enums.base_behavior.delivery"
          },
          {
            "value": "pickup",
            "label": "md.enums.base_behavior.pickup"
          }
        ]
      },
      {
        "key": "requiresTable",
        "label": "md.fields.requires_table",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "requiresCustomer",
        "label": "md.fields.requires_customer",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "requiresAddress",
        "label": "md.fields.requires_address",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "orderFlowId",
        "label": "md.fields.order_flow_id",
        "required": false,
        "type": "reference",
        "ref": "config.order_flow"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "baseBehavior": "",
      "requiresTable": false,
      "requiresCustomer": false,
      "requiresAddress": false,
      "sortOrder": 0,
      "isActive": true,
      "orderFlowId": null
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "baseBehavior",
        "label": "md.fields.base_behavior",
        "type": "select",
        "options": [
          {
            "value": "dine_in",
            "label": "md.enums.base_behavior.dine_in"
          },
          {
            "value": "takeaway",
            "label": "md.enums.base_behavior.takeaway"
          },
          {
            "value": "delivery",
            "label": "md.enums.base_behavior.delivery"
          },
          {
            "value": "pickup",
            "label": "md.enums.base_behavior.pickup"
          }
        ]
      },
      {
        "key": "requiresTable",
        "label": "md.fields.requires_table",
        "type": "toggle"
      },
      {
        "key": "requiresCustomer",
        "label": "md.fields.requires_customer",
        "type": "toggle"
      },
      {
        "key": "requiresAddress",
        "label": "md.fields.requires_address",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      },
      {
        "key": "orderFlowId",
        "label": "md.fields.order_flow_id",
        "type": "reference",
        "ref": "config.order_flow"
      }
    ],
    "route": "/pos/sale-types",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.order_flow": {
    "key": "config.order_flow",
    "title": "md.resources.config_order_flow",
    "path": "/api/v1/menu/config/order-flows",
    "readPermission": "ho.config.order_flows.read",
    "writePermission": "ho.config.order_flows.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": ""
    },
    "children": [
      "config.order_flow_step"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      }
    ],
    "route": "/pos/order-flows",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.order_flow_step": {
    "key": "config.order_flow_step",
    "title": "md.resources.config_order_flow_step",
    "path": "/api/v1/menu/config/order-flows/{parentId}/steps",
    "readPermission": "ho.config.order_flows.read",
    "writePermission": "ho.config.order_flows.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "stepType",
        "type": "select",
        "options": [
          {
            "value": "select_table",
            "label": "md.enums.step_type.select_table"
          },
          {
            "value": "enter_guests",
            "label": "md.enums.step_type.enter_guests"
          },
          {
            "value": "select_customer",
            "label": "md.enums.step_type.select_customer"
          },
          {
            "value": "prompt",
            "label": "md.enums.step_type.prompt"
          },
          {
            "value": "take_order",
            "label": "md.enums.step_type.take_order"
          },
          {
            "value": "send_to_kitchen",
            "label": "md.enums.step_type.send_to_kitchen"
          },
          {
            "value": "print_bill",
            "label": "md.enums.step_type.print_bill"
          },
          {
            "value": "take_payment",
            "label": "md.enums.step_type.take_payment"
          },
          {
            "value": "assign_driver",
            "label": "md.enums.step_type.assign_driver"
          },
          {
            "value": "close",
            "label": "md.enums.step_type.close"
          },
          {
            "value": "accept_order",
            "label": "md.enums.step_type.accept_order"
          },
          {
            "value": "mark_ready",
            "label": "md.enums.step_type.mark_ready"
          },
          {
            "value": "hand_over",
            "label": "md.enums.step_type.hand_over"
          },
          {
            "value": "out_for_delivery",
            "label": "md.enums.step_type.out_for_delivery"
          },
          {
            "value": "deliver",
            "label": "md.enums.step_type.deliver"
          }
        ],
        "header": "md.fields.step_type"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "stepType",
        "label": "md.fields.step_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "select_table",
            "label": "md.enums.step_type.select_table"
          },
          {
            "value": "enter_guests",
            "label": "md.enums.step_type.enter_guests"
          },
          {
            "value": "select_customer",
            "label": "md.enums.step_type.select_customer"
          },
          {
            "value": "prompt",
            "label": "md.enums.step_type.prompt"
          },
          {
            "value": "take_order",
            "label": "md.enums.step_type.take_order"
          },
          {
            "value": "send_to_kitchen",
            "label": "md.enums.step_type.send_to_kitchen"
          },
          {
            "value": "print_bill",
            "label": "md.enums.step_type.print_bill"
          },
          {
            "value": "take_payment",
            "label": "md.enums.step_type.take_payment"
          },
          {
            "value": "assign_driver",
            "label": "md.enums.step_type.assign_driver"
          },
          {
            "value": "close",
            "label": "md.enums.step_type.close"
          },
          {
            "value": "accept_order",
            "label": "md.enums.step_type.accept_order"
          },
          {
            "value": "mark_ready",
            "label": "md.enums.step_type.mark_ready"
          },
          {
            "value": "hand_over",
            "label": "md.enums.step_type.hand_over"
          },
          {
            "value": "out_for_delivery",
            "label": "md.enums.step_type.out_for_delivery"
          },
          {
            "value": "deliver",
            "label": "md.enums.step_type.deliver"
          }
        ]
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": true,
        "type": "number"
      },
      {
        "key": "isRequired",
        "label": "md.fields.is_required",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "config",
        "label": "md.fields.config",
        "required": false,
        "type": "json"
      }
    ],
    "empty": {
      "stepType": "",
      "sortOrder": null,
      "isRequired": true,
      "config": "{}"
    },
    "children": [],
    "filters": [
      {
        "key": "stepType",
        "label": "md.fields.step_type",
        "type": "select",
        "options": [
          {
            "value": "select_table",
            "label": "md.enums.step_type.select_table"
          },
          {
            "value": "enter_guests",
            "label": "md.enums.step_type.enter_guests"
          },
          {
            "value": "select_customer",
            "label": "md.enums.step_type.select_customer"
          },
          {
            "value": "prompt",
            "label": "md.enums.step_type.prompt"
          },
          {
            "value": "take_order",
            "label": "md.enums.step_type.take_order"
          },
          {
            "value": "send_to_kitchen",
            "label": "md.enums.step_type.send_to_kitchen"
          },
          {
            "value": "print_bill",
            "label": "md.enums.step_type.print_bill"
          },
          {
            "value": "take_payment",
            "label": "md.enums.step_type.take_payment"
          },
          {
            "value": "assign_driver",
            "label": "md.enums.step_type.assign_driver"
          },
          {
            "value": "close",
            "label": "md.enums.step_type.close"
          },
          {
            "value": "accept_order",
            "label": "md.enums.step_type.accept_order"
          },
          {
            "value": "mark_ready",
            "label": "md.enums.step_type.mark_ready"
          },
          {
            "value": "hand_over",
            "label": "md.enums.step_type.hand_over"
          },
          {
            "value": "out_for_delivery",
            "label": "md.enums.step_type.out_for_delivery"
          },
          {
            "value": "deliver",
            "label": "md.enums.step_type.deliver"
          }
        ]
      },
      {
        "key": "isRequired",
        "label": "md.fields.is_required",
        "type": "toggle"
      }
    ],
    "parent": "config.order_flow"
  },
  "config.pos_layout": {
    "key": "config.pos_layout",
    "title": "md.resources.config_pos_layout",
    "path": "/api/v1/menu/config/pos-layouts",
    "readPermission": "ho.config.pos_layouts.read",
    "writePermission": "ho.config.pos_layouts.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "screenClass",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ],
        "header": "md.fields.screen_class"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "screenClass",
        "label": "md.fields.screen_class",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ]
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "screenClass": ""
    },
    "children": [
      "config.pos_layout_section"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "screenClass",
        "label": "md.fields.screen_class",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.screen_class.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.screen_class.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.screen_class.handheld"
          }
        ]
      }
    ],
    "route": "/pos/pos-layouts",
    "group": "pos"
  },
  "config.pos_layout_section": {
    "key": "config.pos_layout_section",
    "title": "md.resources.config_pos_layout_section",
    "path": "/api/v1/menu/config/pos-layouts/{parentId}/sections",
    "readPermission": "ho.config.pos_layouts.read",
    "writePermission": "ho.config.pos_layouts.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "sectionType",
        "type": "select",
        "options": [
          {
            "value": "table_map",
            "label": "md.enums.section_type.table_map"
          },
          {
            "value": "menu_listing",
            "label": "md.enums.section_type.menu_listing"
          },
          {
            "value": "order_list",
            "label": "md.enums.section_type.order_list"
          },
          {
            "value": "online_orders",
            "label": "md.enums.section_type.online_orders"
          },
          {
            "value": "functions",
            "label": "md.enums.section_type.functions"
          },
          {
            "value": "reservations",
            "label": "md.enums.section_type.reservations"
          },
          {
            "value": "table_qr",
            "label": "md.enums.section_type.table_qr"
          }
        ],
        "header": "md.fields.section_type"
      },
      {
        "key": "menuId",
        "type": "reference",
        "ref": "menu.menu",
        "header": "md.fields.menu_id"
      },
      {
        "key": "menuLayoutId",
        "type": "reference",
        "ref": "menu.menu_layout",
        "header": "md.fields.menu_layout_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "sectionType",
        "label": "md.fields.section_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "table_map",
            "label": "md.enums.section_type.table_map"
          },
          {
            "value": "menu_listing",
            "label": "md.enums.section_type.menu_listing"
          },
          {
            "value": "order_list",
            "label": "md.enums.section_type.order_list"
          },
          {
            "value": "online_orders",
            "label": "md.enums.section_type.online_orders"
          },
          {
            "value": "functions",
            "label": "md.enums.section_type.functions"
          },
          {
            "value": "reservations",
            "label": "md.enums.section_type.reservations"
          },
          {
            "value": "table_qr",
            "label": "md.enums.section_type.table_qr"
          }
        ]
      },
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "required": false,
        "type": "reference",
        "ref": "menu.menu"
      },
      {
        "key": "menuLayoutId",
        "label": "md.fields.menu_layout_id",
        "required": false,
        "type": "reference",
        "ref": "menu.menu_layout"
      },
      {
        "key": "defaultSaleTypeId",
        "label": "md.fields.default_sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "listFilter",
        "label": "md.fields.list_filter",
        "required": false,
        "type": "json"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "name": "",
      "nameI18n": {},
      "sectionType": "",
      "menuId": null,
      "menuLayoutId": null,
      "defaultSaleTypeId": null,
      "listFilter": "{}",
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "sectionType",
        "label": "md.fields.section_type",
        "type": "select",
        "options": [
          {
            "value": "table_map",
            "label": "md.enums.section_type.table_map"
          },
          {
            "value": "menu_listing",
            "label": "md.enums.section_type.menu_listing"
          },
          {
            "value": "order_list",
            "label": "md.enums.section_type.order_list"
          },
          {
            "value": "online_orders",
            "label": "md.enums.section_type.online_orders"
          },
          {
            "value": "functions",
            "label": "md.enums.section_type.functions"
          },
          {
            "value": "reservations",
            "label": "md.enums.section_type.reservations"
          },
          {
            "value": "table_qr",
            "label": "md.enums.section_type.table_qr"
          }
        ]
      },
      {
        "key": "menuId",
        "label": "md.fields.menu_id",
        "type": "reference",
        "ref": "menu.menu"
      },
      {
        "key": "menuLayoutId",
        "label": "md.fields.menu_layout_id",
        "type": "reference",
        "ref": "menu.menu_layout"
      },
      {
        "key": "defaultSaleTypeId",
        "label": "md.fields.default_sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      }
    ],
    "parent": "config.pos_layout",
    "lookupPath": "/api/v1/menu/config/pos-layout-sections"
  },
  "config.pos_profile": {
    "key": "config.pos_profile",
    "title": "md.resources.config_pos_profile",
    "path": "/api/v1/menu/config/pos-profiles",
    "readPermission": "ho.config.pos_profiles.read",
    "writePermission": "ho.config.pos_profiles.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "theme",
        "type": "select",
        "options": [
          {
            "value": "g10",
            "label": "md.enums.theme.g10"
          },
          {
            "value": "g100",
            "label": "md.enums.theme.g100"
          }
        ],
        "header": "md.fields.theme"
      },
      {
        "key": "density",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.density.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.density.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.density.handheld"
          }
        ],
        "header": "md.fields.density"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "posLayoutId",
        "type": "reference",
        "ref": "config.pos_layout",
        "header": "md.fields.pos_layout_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "posLayoutId",
        "label": "md.fields.pos_layout_id",
        "required": true,
        "type": "reference",
        "ref": "config.pos_layout"
      },
      {
        "key": "defaultSaleTypeId",
        "label": "md.fields.default_sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "theme",
        "label": "md.fields.theme",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "g10",
            "label": "md.enums.theme.g10"
          },
          {
            "value": "g100",
            "label": "md.enums.theme.g100"
          }
        ]
      },
      {
        "key": "density",
        "label": "md.fields.density",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.density.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.density.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.density.handheld"
          }
        ]
      },
      {
        "key": "largeText",
        "label": "md.fields.large_text",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "settings",
        "label": "md.fields.settings",
        "required": false,
        "type": "json"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "posLayoutId": null,
      "defaultSaleTypeId": null,
      "theme": "g10",
      "density": "terminal",
      "largeText": false,
      "settings": "{}"
    },
    "children": [
      "config.pos_profile_sale_type",
      "config.pos_button"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "posLayoutId",
        "label": "md.fields.pos_layout_id",
        "type": "reference",
        "ref": "config.pos_layout"
      },
      {
        "key": "defaultSaleTypeId",
        "label": "md.fields.default_sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "theme",
        "label": "md.fields.theme",
        "type": "select",
        "options": [
          {
            "value": "g10",
            "label": "md.enums.theme.g10"
          },
          {
            "value": "g100",
            "label": "md.enums.theme.g100"
          }
        ]
      },
      {
        "key": "density",
        "label": "md.fields.density",
        "type": "select",
        "options": [
          {
            "value": "terminal",
            "label": "md.enums.density.terminal"
          },
          {
            "value": "tablet",
            "label": "md.enums.density.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.density.handheld"
          }
        ]
      },
      {
        "key": "largeText",
        "label": "md.fields.large_text",
        "type": "toggle"
      }
    ],
    "route": "/pos/pos-profiles",
    "group": "pos"
  },
  "config.pos_profile_sale_type": {
    "key": "config.pos_profile_sale_type",
    "title": "md.resources.config_pos_profile_sale_type",
    "path": "/api/v1/menu/config/pos-profiles/{parentId}/sale-types",
    "readPermission": "ho.config.pos_profiles.read",
    "writePermission": "ho.config.pos_profiles.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      },
      {
        "key": "orderFlowId",
        "type": "reference",
        "ref": "config.order_flow",
        "header": "md.fields.order_flow_id"
      },
      {
        "key": "isDefault",
        "type": "toggle",
        "header": "md.fields.is_default"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": true,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "orderFlowId",
        "label": "md.fields.order_flow_id",
        "required": true,
        "type": "reference",
        "ref": "config.order_flow"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "saleTypeId": null,
      "orderFlowId": null,
      "isDefault": false,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "orderFlowId",
        "label": "md.fields.order_flow_id",
        "type": "reference",
        "ref": "config.order_flow"
      },
      {
        "key": "isDefault",
        "label": "md.fields.is_default",
        "type": "toggle"
      }
    ],
    "parent": "config.pos_profile"
  },
  "config.pos_button": {
    "key": "config.pos_button",
    "title": "md.resources.config_pos_button",
    "path": "/api/v1/menu/config/pos-profiles/{parentId}/buttons",
    "readPermission": "ho.config.pos_profiles.read",
    "writePermission": "ho.config.pos_profiles.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "placement",
        "type": "select",
        "options": [
          {
            "value": "order_rail",
            "label": "md.enums.placement.order_rail"
          },
          {
            "value": "line_rail",
            "label": "md.enums.placement.line_rail"
          },
          {
            "value": "command_bar",
            "label": "md.enums.placement.command_bar"
          },
          {
            "value": "more_sheet",
            "label": "md.enums.placement.more_sheet"
          },
          {
            "value": "order_header",
            "label": "md.enums.placement.order_header"
          },
          {
            "value": "table_sheet",
            "label": "md.enums.placement.table_sheet"
          }
        ],
        "header": "md.fields.placement"
      },
      {
        "key": "role",
        "type": "select",
        "options": [
          {
            "value": "send",
            "label": "md.enums.role.send"
          },
          {
            "value": "pay",
            "label": "md.enums.role.pay"
          },
          {
            "value": "bill",
            "label": "md.enums.role.bill"
          },
          {
            "value": "danger",
            "label": "md.enums.role.danger"
          },
          {
            "value": "tool",
            "label": "md.enums.role.tool"
          }
        ],
        "header": "md.fields.role"
      },
      {
        "key": "actionCode",
        "type": "reference",
        "ref": "config.pos_action",
        "header": "md.fields.action_code"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "placement",
        "label": "md.fields.placement",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "order_rail",
            "label": "md.enums.placement.order_rail"
          },
          {
            "value": "line_rail",
            "label": "md.enums.placement.line_rail"
          },
          {
            "value": "command_bar",
            "label": "md.enums.placement.command_bar"
          },
          {
            "value": "more_sheet",
            "label": "md.enums.placement.more_sheet"
          },
          {
            "value": "order_header",
            "label": "md.enums.placement.order_header"
          },
          {
            "value": "table_sheet",
            "label": "md.enums.placement.table_sheet"
          }
        ]
      },
      {
        "key": "actionCode",
        "label": "md.fields.action_code",
        "required": true,
        "type": "reference",
        "ref": "config.pos_action"
      },
      {
        "key": "role",
        "label": "md.fields.role",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "send",
            "label": "md.enums.role.send"
          },
          {
            "value": "pay",
            "label": "md.enums.role.pay"
          },
          {
            "value": "bill",
            "label": "md.enums.role.bill"
          },
          {
            "value": "danger",
            "label": "md.enums.role.danger"
          },
          {
            "value": "tool",
            "label": "md.enums.role.tool"
          }
        ]
      },
      {
        "key": "labelOverride",
        "label": "md.fields.label_override",
        "required": false,
        "type": "text"
      },
      {
        "key": "icon",
        "label": "md.fields.icon",
        "required": false,
        "type": "text"
      },
      {
        "key": "shortcutKey",
        "label": "md.fields.shortcut_key",
        "required": false,
        "type": "text"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "config",
        "label": "md.fields.config",
        "required": false,
        "type": "json"
      }
    ],
    "empty": {
      "placement": "",
      "actionCode": "",
      "role": "tool",
      "labelOverride": null,
      "icon": null,
      "shortcutKey": null,
      "sortOrder": 0,
      "config": "{}"
    },
    "children": [],
    "filters": [
      {
        "key": "placement",
        "label": "md.fields.placement",
        "type": "select",
        "options": [
          {
            "value": "order_rail",
            "label": "md.enums.placement.order_rail"
          },
          {
            "value": "line_rail",
            "label": "md.enums.placement.line_rail"
          },
          {
            "value": "command_bar",
            "label": "md.enums.placement.command_bar"
          },
          {
            "value": "more_sheet",
            "label": "md.enums.placement.more_sheet"
          },
          {
            "value": "order_header",
            "label": "md.enums.placement.order_header"
          },
          {
            "value": "table_sheet",
            "label": "md.enums.placement.table_sheet"
          }
        ]
      },
      {
        "key": "actionCode",
        "label": "md.fields.action_code",
        "type": "reference",
        "ref": "config.pos_action"
      },
      {
        "key": "role",
        "label": "md.fields.role",
        "type": "select",
        "options": [
          {
            "value": "send",
            "label": "md.enums.role.send"
          },
          {
            "value": "pay",
            "label": "md.enums.role.pay"
          },
          {
            "value": "bill",
            "label": "md.enums.role.bill"
          },
          {
            "value": "danger",
            "label": "md.enums.role.danger"
          },
          {
            "value": "tool",
            "label": "md.enums.role.tool"
          }
        ]
      }
    ],
    "parent": "config.pos_profile"
  },
  "config.payment_method": {
    "key": "config.payment_method",
    "title": "md.resources.config_payment_method",
    "path": "/api/v1/menu/config/payment-methods",
    "readPermission": "ho.config.payment_methods.read",
    "writePermission": "ho.config.payment_methods.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "methodType",
        "type": "select",
        "options": [
          {
            "value": "cash",
            "label": "md.enums.method_type.cash"
          },
          {
            "value": "card",
            "label": "md.enums.method_type.card"
          },
          {
            "value": "qr",
            "label": "md.enums.method_type.qr"
          },
          {
            "value": "bank_transfer",
            "label": "md.enums.method_type.bank_transfer"
          },
          {
            "value": "e_wallet",
            "label": "md.enums.method_type.e_wallet"
          },
          {
            "value": "voucher",
            "label": "md.enums.method_type.voucher"
          },
          {
            "value": "points",
            "label": "md.enums.method_type.points"
          },
          {
            "value": "pay_later",
            "label": "md.enums.method_type.pay_later"
          },
          {
            "value": "other",
            "label": "md.enums.method_type.other"
          }
        ],
        "header": "md.fields.method_type"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "providerAccountId",
        "type": "reference",
        "ref": "integration.provider_account",
        "header": "md.fields.provider_account_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "methodType",
        "label": "md.fields.method_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "cash",
            "label": "md.enums.method_type.cash"
          },
          {
            "value": "card",
            "label": "md.enums.method_type.card"
          },
          {
            "value": "qr",
            "label": "md.enums.method_type.qr"
          },
          {
            "value": "bank_transfer",
            "label": "md.enums.method_type.bank_transfer"
          },
          {
            "value": "e_wallet",
            "label": "md.enums.method_type.e_wallet"
          },
          {
            "value": "voucher",
            "label": "md.enums.method_type.voucher"
          },
          {
            "value": "points",
            "label": "md.enums.method_type.points"
          },
          {
            "value": "pay_later",
            "label": "md.enums.method_type.pay_later"
          },
          {
            "value": "other",
            "label": "md.enums.method_type.other"
          }
        ]
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "required": false,
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "providerCode",
        "label": "md.fields.provider_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "providerName",
        "label": "md.fields.provider_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "requiresHo",
        "label": "md.fields.requires_ho",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "allowsChange",
        "label": "md.fields.allows_change",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "opensDrawer",
        "label": "md.fields.opens_drawer",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "requiresReference",
        "label": "md.fields.requires_reference",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "manualConfirmApprovalAbove",
        "label": "md.fields.manual_confirm_approval_above",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "icon",
        "label": "md.fields.icon",
        "required": false,
        "type": "text"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "methodType": "",
      "providerAccountId": null,
      "providerCode": null,
      "providerName": null,
      "requiresHo": false,
      "allowsChange": false,
      "opensDrawer": false,
      "requiresReference": false,
      "manualConfirmApprovalAbove": null,
      "sortOrder": 0,
      "icon": null,
      "isActive": true
    },
    "children": [
      "config.payment_method_assignment"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "methodType",
        "label": "md.fields.method_type",
        "type": "select",
        "options": [
          {
            "value": "cash",
            "label": "md.enums.method_type.cash"
          },
          {
            "value": "card",
            "label": "md.enums.method_type.card"
          },
          {
            "value": "qr",
            "label": "md.enums.method_type.qr"
          },
          {
            "value": "bank_transfer",
            "label": "md.enums.method_type.bank_transfer"
          },
          {
            "value": "e_wallet",
            "label": "md.enums.method_type.e_wallet"
          },
          {
            "value": "voucher",
            "label": "md.enums.method_type.voucher"
          },
          {
            "value": "points",
            "label": "md.enums.method_type.points"
          },
          {
            "value": "pay_later",
            "label": "md.enums.method_type.pay_later"
          },
          {
            "value": "other",
            "label": "md.enums.method_type.other"
          }
        ]
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "requiresHo",
        "label": "md.fields.requires_ho",
        "type": "toggle"
      },
      {
        "key": "allowsChange",
        "label": "md.fields.allows_change",
        "type": "toggle"
      },
      {
        "key": "opensDrawer",
        "label": "md.fields.opens_drawer",
        "type": "toggle"
      },
      {
        "key": "requiresReference",
        "label": "md.fields.requires_reference",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/pos/payment-methods",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.payment_method_assignment": {
    "key": "config.payment_method_assignment",
    "title": "md.resources.config_payment_method_assignment",
    "path": "/api/v1/menu/config/payment-methods/{parentId}/assignments",
    "readPermission": "ho.config.payment_methods.read",
    "writePermission": "ho.config.payment_methods.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "posProfileId",
        "type": "reference",
        "ref": "config.pos_profile",
        "header": "md.fields.pos_profile_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "required": false,
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": false,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "isEnabled",
        "label": "md.fields.is_enabled",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "storeId": null,
      "posProfileId": null,
      "salesChannelId": null,
      "isEnabled": true
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "isEnabled",
        "label": "md.fields.is_enabled",
        "type": "toggle"
      }
    ],
    "parent": "config.payment_method",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "config.delivery_service": {
    "key": "config.delivery_service",
    "title": "md.resources.config_delivery_service",
    "path": "/api/v1/menu/config/delivery-services",
    "readPermission": "ho.config.delivery_services.read",
    "writePermission": "ho.config.delivery_services.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "kind",
        "type": "select",
        "options": [
          {
            "value": "internal",
            "label": "md.enums.kind.internal"
          },
          {
            "value": "external",
            "label": "md.enums.kind.external"
          }
        ],
        "header": "md.fields.kind"
      },
      {
        "key": "feeMode",
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.fee_mode.manual"
          },
          {
            "value": "fixed",
            "label": "md.enums.fee_mode.fixed"
          },
          {
            "value": "quote",
            "label": "md.enums.fee_mode.quote"
          }
        ],
        "header": "md.fields.fee_mode"
      },
      {
        "key": "providerAccountId",
        "type": "reference",
        "ref": "integration.provider_account",
        "header": "md.fields.provider_account_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "kind",
        "label": "md.fields.kind",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "internal",
            "label": "md.enums.kind.internal"
          },
          {
            "value": "external",
            "label": "md.enums.kind.external"
          }
        ]
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "required": false,
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "providerCode",
        "label": "md.fields.provider_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "providerName",
        "label": "md.fields.provider_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "serviceType",
        "label": "md.fields.service_type",
        "required": false,
        "type": "text"
      },
      {
        "key": "feeMode",
        "label": "md.fields.fee_mode",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.fee_mode.manual"
          },
          {
            "value": "fixed",
            "label": "md.enums.fee_mode.fixed"
          },
          {
            "value": "quote",
            "label": "md.enums.fee_mode.quote"
          }
        ]
      },
      {
        "key": "fixedFee",
        "label": "md.fields.fixed_fee",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "requiresHo",
        "label": "md.fields.requires_ho",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "nameI18n": {},
      "kind": "",
      "providerAccountId": null,
      "providerCode": null,
      "providerName": null,
      "serviceType": null,
      "feeMode": "manual",
      "fixedFee": null,
      "requiresHo": false,
      "sortOrder": 0,
      "isActive": true
    },
    "children": [
      "config.delivery_service_assignment"
    ],
    "filters": [
      {
        "key": "kind",
        "label": "md.fields.kind",
        "type": "select",
        "options": [
          {
            "value": "internal",
            "label": "md.enums.kind.internal"
          },
          {
            "value": "external",
            "label": "md.enums.kind.external"
          }
        ]
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "feeMode",
        "label": "md.fields.fee_mode",
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.fee_mode.manual"
          },
          {
            "value": "fixed",
            "label": "md.enums.fee_mode.fixed"
          },
          {
            "value": "quote",
            "label": "md.enums.fee_mode.quote"
          }
        ]
      },
      {
        "key": "requiresHo",
        "label": "md.fields.requires_ho",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/pos/delivery-services",
    "group": "pos"
  },
  "config.delivery_service_assignment": {
    "key": "config.delivery_service_assignment",
    "title": "md.resources.config_delivery_service_assignment",
    "path": "/api/v1/menu/config/delivery-services/{parentId}/assignments",
    "readPermission": "ho.config.delivery_services.read",
    "writePermission": "ho.config.delivery_services.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "required": false,
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "isEnabled",
        "label": "md.fields.is_enabled",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "storeId": null,
      "posProfileId": null,
      "saleTypeId": null,
      "isEnabled": true
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "isEnabled",
        "label": "md.fields.is_enabled",
        "type": "toggle"
      }
    ],
    "parent": "config.delivery_service",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "config.charge_type": {
    "key": "config.charge_type",
    "title": "md.resources.config_charge_type",
    "path": "/api/v1/menu/config/charge-types",
    "readPermission": "ho.config.charge_types.read",
    "writePermission": "ho.config.charge_types.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "method",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "fixed",
            "label": "md.enums.method.fixed"
          }
        ],
        "header": "md.fields.method"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "taxCategoryId",
        "type": "reference",
        "ref": "catalog.tax_category",
        "header": "md.fields.tax_category_id"
      },
      {
        "key": "value",
        "type": "decimal",
        "header": "md.fields.value"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "method",
        "label": "md.fields.method",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "fixed",
            "label": "md.enums.method.fixed"
          }
        ]
      },
      {
        "key": "value",
        "label": "md.fields.value",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "amountEntry",
        "label": "md.fields.amount_entry",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "maxValue",
        "label": "md.fields.max_value",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "isTaxable",
        "label": "md.fields.is_taxable",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "autoApply",
        "label": "md.fields.auto_apply",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "appliesAfterTax",
        "label": "md.fields.applies_after_tax",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "applyRules",
        "label": "md.fields.apply_rules",
        "required": false,
        "type": "json"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "method": "",
      "value": null,
      "amountEntry": false,
      "maxValue": null,
      "isTaxable": true,
      "taxCategoryId": null,
      "autoApply": false,
      "appliesAfterTax": false,
      "applyRules": "{}",
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "method",
        "label": "md.fields.method",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "fixed",
            "label": "md.enums.method.fixed"
          }
        ]
      },
      {
        "key": "amountEntry",
        "label": "md.fields.amount_entry",
        "type": "toggle"
      },
      {
        "key": "isTaxable",
        "label": "md.fields.is_taxable",
        "type": "toggle"
      },
      {
        "key": "taxCategoryId",
        "label": "md.fields.tax_category_id",
        "type": "reference",
        "ref": "catalog.tax_category"
      },
      {
        "key": "autoApply",
        "label": "md.fields.auto_apply",
        "type": "toggle"
      },
      {
        "key": "appliesAfterTax",
        "label": "md.fields.applies_after_tax",
        "type": "toggle"
      }
    ],
    "route": "/pos/charge-types",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.brand_site": {
    "key": "config.brand_site",
    "title": "md.resources.config_brand_site",
    "path": "/api/v1/menu/config/brand-sites",
    "readPermission": "ho.online.brand_sites.read",
    "writePermission": "ho.online.brand_sites.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "siteName",
        "type": "text",
        "header": "md.fields.site_name"
      },
      {
        "key": "defaultLanguage",
        "type": "text",
        "header": "md.fields.default_language"
      },
      {
        "key": "languages",
        "type": "text",
        "header": "md.fields.languages"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "siteName",
        "label": "md.fields.site_name",
        "required": true,
        "type": "text"
      },
      {
        "key": "defaultLanguage",
        "label": "md.fields.default_language",
        "required": false,
        "type": "text"
      },
      {
        "key": "languages",
        "label": "md.fields.languages",
        "required": false,
        "type": "text"
      },
      {
        "key": "logoUrl",
        "label": "md.fields.logo_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "iconUrl",
        "label": "md.fields.icon_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "ogImageUrl",
        "label": "md.fields.og_image_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "theme",
        "label": "md.fields.theme",
        "required": false,
        "type": "json"
      },
      {
        "key": "supportPhone",
        "label": "md.fields.support_phone",
        "required": false,
        "type": "text"
      },
      {
        "key": "supportEmail",
        "label": "md.fields.support_email",
        "required": false,
        "type": "text"
      },
      {
        "key": "privacyNoticeVersion",
        "label": "md.fields.privacy_notice_version",
        "required": false,
        "type": "text"
      },
      {
        "key": "allowAiCrawlers",
        "label": "md.fields.allow_ai_crawlers",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "settings",
        "label": "md.fields.settings",
        "required": false,
        "type": "json"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "siteName": "",
      "defaultLanguage": "vi",
      "languages": "vi",
      "logoUrl": null,
      "iconUrl": null,
      "ogImageUrl": null,
      "theme": "{}",
      "supportPhone": null,
      "supportEmail": null,
      "privacyNoticeVersion": null,
      "allowAiCrawlers": true,
      "settings": "{}",
      "isActive": true
    },
    "children": [
      "config.brand_site_domain"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "allowAiCrawlers",
        "label": "md.fields.allow_ai_crawlers",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/online/brand-sites",
    "group": "online",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.brand_site_domain": {
    "key": "config.brand_site_domain",
    "title": "md.resources.config_brand_site_domain",
    "path": "/api/v1/menu/config/brand-sites/{parentId}/domains",
    "readPermission": "ho.online.brand_sites.read",
    "writePermission": "ho.online.brand_sites.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "host",
        "type": "text",
        "header": "md.fields.host"
      },
      {
        "key": "isPrimary",
        "type": "toggle",
        "header": "md.fields.is_primary"
      }
    ],
    "fields": [
      {
        "key": "host",
        "label": "md.fields.host",
        "required": true,
        "type": "text"
      },
      {
        "key": "isPrimary",
        "label": "md.fields.is_primary",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "host": "",
      "isPrimary": false
    },
    "children": [],
    "filters": [
      {
        "key": "isPrimary",
        "label": "md.fields.is_primary",
        "type": "toggle"
      }
    ],
    "parent": "config.brand_site"
  },
  "config.delivery_fee_rule": {
    "key": "config.delivery_fee_rule",
    "title": "md.resources.config_delivery_fee_rule",
    "path": "/api/v1/menu/config/delivery-fee-rules",
    "readPermission": "ho.online.delivery_fee_rules.read",
    "writePermission": "ho.online.delivery_fee_rules.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "salesChannelId",
        "type": "reference",
        "ref": "config.sales_channel",
        "header": "md.fields.sales_channel_id"
      },
      {
        "key": "baseDistanceM",
        "type": "number",
        "header": "md.fields.base_distance_m"
      },
      {
        "key": "stepFee",
        "type": "decimal",
        "header": "md.fields.step_fee"
      },
      {
        "key": "maxDistanceM",
        "type": "number",
        "header": "md.fields.max_distance_m"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": false,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "baseDistanceM",
        "label": "md.fields.base_distance_m",
        "required": false,
        "type": "number"
      },
      {
        "key": "baseFee",
        "label": "md.fields.base_fee",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "stepM",
        "label": "md.fields.step_m",
        "required": false,
        "type": "number"
      },
      {
        "key": "stepFee",
        "label": "md.fields.step_fee",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "maxDistanceM",
        "label": "md.fields.max_distance_m",
        "required": false,
        "type": "number"
      },
      {
        "key": "freeFromAmount",
        "label": "md.fields.free_from_amount",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "minimumOrderAmount",
        "label": "md.fields.minimum_order_amount",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "date"
      },
      {
        "key": "priority",
        "label": "md.fields.priority",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "storeId": null,
      "salesChannelId": null,
      "code": "",
      "name": "",
      "baseDistanceM": 0,
      "baseFee": 0.0,
      "stepM": 1000,
      "stepFee": 0.0,
      "maxDistanceM": null,
      "freeFromAmount": null,
      "minimumOrderAmount": null,
      "validFrom": null,
      "validTo": null,
      "priority": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "date"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "date"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/online/delivery-fee-rules",
    "group": "online",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "online.channel_store": {
    "key": "online.channel_store",
    "title": "md.resources.online_channel_store",
    "path": "/api/v1/onlineordering/channel-stores",
    "readPermission": "ho.online.channel_stores.read",
    "writePermission": "ho.online.channel_stores.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "salesChannelId",
        "type": "reference",
        "ref": "config.sales_channel",
        "header": "md.fields.sales_channel_id"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "open",
            "label": "md.enums.status.open"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "pausedReason",
        "type": "select",
        "options": [
          {
            "value": "store_offline",
            "label": "md.enums.paused_reason.store_offline"
          },
          {
            "value": "staff_paused",
            "label": "md.enums.paused_reason.staff_paused"
          },
          {
            "value": "capacity",
            "label": "md.enums.paused_reason.capacity"
          },
          {
            "value": "outside_hours",
            "label": "md.enums.paused_reason.outside_hours"
          },
          {
            "value": "max_orders",
            "label": "md.enums.paused_reason.max_orders"
          }
        ],
        "header": "md.fields.paused_reason"
      },
      {
        "key": "prepMinutes",
        "type": "number",
        "header": "md.fields.prep_minutes"
      },
      {
        "key": "autoAccept",
        "type": "toggle",
        "header": "md.fields.auto_accept"
      }
    ],
    "fields": [
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "required": true,
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "externalStoreId",
        "label": "md.fields.external_store_id",
        "required": false,
        "type": "text"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "open",
            "label": "md.enums.status.open"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      },
      {
        "key": "pausedReason",
        "label": "md.fields.paused_reason",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "store_offline",
            "label": "md.enums.paused_reason.store_offline"
          },
          {
            "value": "staff_paused",
            "label": "md.enums.paused_reason.staff_paused"
          },
          {
            "value": "capacity",
            "label": "md.enums.paused_reason.capacity"
          },
          {
            "value": "outside_hours",
            "label": "md.enums.paused_reason.outside_hours"
          },
          {
            "value": "max_orders",
            "label": "md.enums.paused_reason.max_orders"
          }
        ]
      },
      {
        "key": "autoAccept",
        "label": "md.fields.auto_accept",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "maxOpenOrders",
        "label": "md.fields.max_open_orders",
        "required": false,
        "type": "number"
      },
      {
        "key": "prepMinutes",
        "label": "md.fields.prep_minutes",
        "required": false,
        "type": "number"
      },
      {
        "key": "allowCod",
        "label": "md.fields.allow_cod",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "maxCodAmount",
        "label": "md.fields.max_cod_amount",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "allowPayAtPickup",
        "label": "md.fields.allow_pay_at_pickup",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "scheduleDays",
        "label": "md.fields.schedule_days",
        "required": false,
        "type": "number"
      },
      {
        "key": "slotMinutes",
        "label": "md.fields.slot_minutes",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": 15,
            "label": "md.enums.slot_minutes.15"
          },
          {
            "value": 30,
            "label": "md.enums.slot_minutes.30"
          },
          {
            "value": 60,
            "label": "md.enums.slot_minutes.60"
          }
        ]
      },
      {
        "key": "slotLimit",
        "label": "md.fields.slot_limit",
        "required": false,
        "type": "number"
      },
      {
        "key": "busyExtraMinutes",
        "label": "md.fields.busy_extra_minutes",
        "required": false,
        "type": "number"
      },
      {
        "key": "busyUntil",
        "label": "md.fields.busy_until",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "depositPercent",
        "label": "md.fields.deposit_percent",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "salesChannelId": null,
      "storeId": null,
      "externalStoreId": null,
      "status": "open",
      "pausedReason": null,
      "autoAccept": false,
      "maxOpenOrders": null,
      "prepMinutes": 15,
      "allowCod": true,
      "maxCodAmount": null,
      "allowPayAtPickup": true,
      "scheduleDays": 0,
      "slotMinutes": 15,
      "slotLimit": null,
      "busyExtraMinutes": 0,
      "busyUntil": null,
      "depositPercent": null
    },
    "children": [
      "online.channel_store_hours"
    ],
    "filters": [
      {
        "key": "salesChannelId",
        "label": "md.fields.sales_channel_id",
        "type": "reference",
        "ref": "config.sales_channel"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "open",
            "label": "md.enums.status.open"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      },
      {
        "key": "pausedReason",
        "label": "md.fields.paused_reason",
        "type": "select",
        "options": [
          {
            "value": "store_offline",
            "label": "md.enums.paused_reason.store_offline"
          },
          {
            "value": "staff_paused",
            "label": "md.enums.paused_reason.staff_paused"
          },
          {
            "value": "capacity",
            "label": "md.enums.paused_reason.capacity"
          },
          {
            "value": "outside_hours",
            "label": "md.enums.paused_reason.outside_hours"
          },
          {
            "value": "max_orders",
            "label": "md.enums.paused_reason.max_orders"
          }
        ]
      },
      {
        "key": "autoAccept",
        "label": "md.fields.auto_accept",
        "type": "toggle"
      },
      {
        "key": "allowCod",
        "label": "md.fields.allow_cod",
        "type": "toggle"
      },
      {
        "key": "allowPayAtPickup",
        "label": "md.fields.allow_pay_at_pickup",
        "type": "toggle"
      },
      {
        "key": "slotMinutes",
        "label": "md.fields.slot_minutes",
        "type": "select",
        "options": [
          {
            "value": 15,
            "label": "md.enums.slot_minutes.15"
          },
          {
            "value": 30,
            "label": "md.enums.slot_minutes.30"
          },
          {
            "value": 60,
            "label": "md.enums.slot_minutes.60"
          }
        ]
      },
      {
        "key": "busyUntil",
        "label": "md.fields.busy_until",
        "type": "datetime"
      }
    ],
    "route": "/online/channel-stores",
    "group": "online"
  },
  "online.blocked_word": {
    "key": "online.blocked_word",
    "title": "md.resources.online_blocked_word",
    "path": "/api/v1/onlineordering/blocked-words",
    "readPermission": "ho.online.blocked_words.read",
    "writePermission": "ho.online.blocked_words.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "phrase",
        "type": "text",
        "header": "md.fields.phrase"
      },
      {
        "key": "match",
        "type": "select",
        "options": [
          {
            "value": "word",
            "label": "md.enums.match.word"
          },
          {
            "value": "anywhere",
            "label": "md.enums.match.anywhere"
          }
        ],
        "header": "md.fields.match"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "note",
        "type": "text",
        "header": "md.fields.note"
      }
    ],
    "fields": [
      {
        "key": "phrase",
        "label": "md.fields.phrase",
        "required": true,
        "type": "text"
      },
      {
        "key": "match",
        "label": "md.fields.match",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "word",
            "label": "md.enums.match.word"
          },
          {
            "value": "anywhere",
            "label": "md.enums.match.anywhere"
          }
        ]
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "note",
        "label": "md.fields.note",
        "required": false,
        "type": "text"
      }
    ],
    "empty": {
      "phrase": "",
      "match": "word",
      "isActive": true,
      "note": null
    },
    "children": [],
    "filters": [
      {
        "key": "match",
        "label": "md.fields.match",
        "type": "select",
        "options": [
          {
            "value": "word",
            "label": "md.enums.match.word"
          },
          {
            "value": "anywhere",
            "label": "md.enums.match.anywhere"
          }
        ]
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/online/blocked-words",
    "group": "online"
  },
  "online.channel_store_hours": {
    "key": "online.channel_store_hours",
    "title": "md.resources.online_channel_store_hours",
    "path": "/api/v1/onlineordering/channel-stores/{parentId}/hours",
    "readPermission": "ho.online.channel_stores.read",
    "writePermission": "ho.online.channel_stores.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "dayOfWeek",
        "type": "select",
        "options": [
          {
            "value": 1,
            "label": "md.enums.day_of_week.1"
          },
          {
            "value": 2,
            "label": "md.enums.day_of_week.2"
          },
          {
            "value": 3,
            "label": "md.enums.day_of_week.3"
          },
          {
            "value": 4,
            "label": "md.enums.day_of_week.4"
          },
          {
            "value": 5,
            "label": "md.enums.day_of_week.5"
          },
          {
            "value": 6,
            "label": "md.enums.day_of_week.6"
          },
          {
            "value": 7,
            "label": "md.enums.day_of_week.7"
          }
        ],
        "header": "md.fields.day_of_week"
      },
      {
        "key": "opensAt",
        "type": "time",
        "header": "md.fields.opens_at"
      },
      {
        "key": "closesAt",
        "type": "time",
        "header": "md.fields.closes_at"
      }
    ],
    "fields": [
      {
        "key": "dayOfWeek",
        "label": "md.fields.day_of_week",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": 1,
            "label": "md.enums.day_of_week.1"
          },
          {
            "value": 2,
            "label": "md.enums.day_of_week.2"
          },
          {
            "value": 3,
            "label": "md.enums.day_of_week.3"
          },
          {
            "value": 4,
            "label": "md.enums.day_of_week.4"
          },
          {
            "value": 5,
            "label": "md.enums.day_of_week.5"
          },
          {
            "value": 6,
            "label": "md.enums.day_of_week.6"
          },
          {
            "value": 7,
            "label": "md.enums.day_of_week.7"
          }
        ]
      },
      {
        "key": "opensAt",
        "label": "md.fields.opens_at",
        "required": true,
        "type": "time"
      },
      {
        "key": "closesAt",
        "label": "md.fields.closes_at",
        "required": true,
        "type": "time"
      }
    ],
    "empty": {
      "dayOfWeek": null,
      "opensAt": null,
      "closesAt": null
    },
    "children": [],
    "filters": [],
    "parent": "online.channel_store"
  },
  "membership.member_club": {
    "key": "membership.member_club",
    "title": "md.resources.membership_member_club",
    "path": "/api/v1/membership/clubs",
    "readPermission": "ho.members.clubs.read",
    "writePermission": "ho.members.clubs.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "pointValue",
        "type": "decimal",
        "header": "md.fields.point_value"
      },
      {
        "key": "tierPeriodMonths",
        "type": "number",
        "header": "md.fields.tier_period_months"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "cardPrefix",
        "label": "md.fields.card_prefix",
        "required": false,
        "type": "text"
      },
      {
        "key": "cardDigits",
        "label": "md.fields.card_digits",
        "required": false,
        "type": "number"
      },
      {
        "key": "accountPrefix",
        "label": "md.fields.account_prefix",
        "required": false,
        "type": "text"
      },
      {
        "key": "contactPrefix",
        "label": "md.fields.contact_prefix",
        "required": false,
        "type": "text"
      },
      {
        "key": "pointValue",
        "label": "md.fields.point_value",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "minRedeemPoints",
        "label": "md.fields.min_redeem_points",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "maxRedeemPercent",
        "label": "md.fields.max_redeem_percent",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "pointsWithOtherDiscounts",
        "label": "md.fields.points_with_other_discounts",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "tierPeriodMonths",
        "label": "md.fields.tier_period_months",
        "required": false,
        "type": "number"
      },
      {
        "key": "tierCountsOrders",
        "label": "md.fields.tier_counts_orders",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "tierCountsRewards",
        "label": "md.fields.tier_counts_rewards",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "tierCountsAdjustments",
        "label": "md.fields.tier_counts_adjustments",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "pointsExpiryMonths",
        "label": "md.fields.points_expiry_months",
        "required": false,
        "type": "number"
      },
      {
        "key": "expiryReminderDays",
        "label": "md.fields.expiry_reminder_days",
        "required": false,
        "type": "text"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "cardPrefix": null,
      "cardDigits": 9,
      "accountPrefix": "A",
      "contactPrefix": "C",
      "pointValue": 0.0,
      "minRedeemPoints": 0.0,
      "maxRedeemPercent": 100.0,
      "pointsWithOtherDiscounts": true,
      "tierPeriodMonths": 12,
      "tierCountsOrders": true,
      "tierCountsRewards": false,
      "tierCountsAdjustments": false,
      "pointsExpiryMonths": 12,
      "expiryReminderDays": "30",
      "isActive": true
    },
    "children": [
      "membership.point_rule"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "pointsWithOtherDiscounts",
        "label": "md.fields.points_with_other_discounts",
        "type": "toggle"
      },
      {
        "key": "tierCountsOrders",
        "label": "md.fields.tier_counts_orders",
        "type": "toggle"
      },
      {
        "key": "tierCountsRewards",
        "label": "md.fields.tier_counts_rewards",
        "type": "toggle"
      },
      {
        "key": "tierCountsAdjustments",
        "label": "md.fields.tier_counts_adjustments",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/loyalty/clubs",
    "group": "loyalty"
  },
  "membership.member_scheme": {
    "key": "membership.member_scheme",
    "title": "md.resources.membership_member_scheme",
    "path": "/api/v1/membership/schemes",
    "readPermission": "ho.members.schemes.read",
    "writePermission": "ho.members.schemes.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "clubId",
        "type": "reference",
        "ref": "membership.member_club",
        "header": "md.fields.club_id"
      },
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "minPoints",
        "type": "decimal",
        "header": "md.fields.min_points"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "required": true,
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "minPoints",
        "label": "md.fields.min_points",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "clubId": null,
      "code": "",
      "name": "",
      "minPoints": 0.0,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "type": "reference",
        "ref": "membership.member_club"
      }
    ],
    "route": "/loyalty/schemes",
    "group": "loyalty",
    "tabOf": [
      {
        "parent": "membership.member_club",
        "field": "clubId"
      }
    ]
  },
  "membership.point_rule": {
    "key": "membership.point_rule",
    "title": "md.resources.membership_point_rule",
    "path": "/api/v1/membership/clubs/{parentId}/point-rules",
    "readPermission": "ho.members.clubs.read",
    "writePermission": "ho.members.clubs.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "schemeId",
        "type": "reference",
        "ref": "membership.member_scheme",
        "header": "md.fields.scheme_id"
      },
      {
        "key": "spendAmount",
        "type": "decimal",
        "header": "md.fields.spend_amount"
      },
      {
        "key": "points",
        "type": "decimal",
        "header": "md.fields.points"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "schemeId",
        "label": "md.fields.scheme_id",
        "required": false,
        "type": "reference",
        "ref": "membership.member_scheme"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "spendAmount",
        "label": "md.fields.spend_amount",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "points",
        "label": "md.fields.points",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "rules",
        "label": "md.fields.rules",
        "required": false,
        "type": "json"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "schemeId": null,
      "code": "",
      "name": "",
      "spendAmount": null,
      "points": null,
      "rules": "{}",
      "validFrom": null,
      "validTo": null,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "schemeId",
        "label": "md.fields.scheme_id",
        "type": "reference",
        "ref": "membership.member_scheme"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "parent": "membership.member_club"
  },
  "membership.member_account": {
    "key": "membership.member_account",
    "title": "md.resources.membership_member_account",
    "path": "/api/v1/membership/accounts",
    "readPermission": "ho.members.accounts.read",
    "writePermission": "ho.members.accounts.manage",
    "labelFields": [
      "account_no"
    ],
    "columns": [
      {
        "key": "accountNo",
        "type": "text",
        "header": "md.fields.account_no"
      },
      {
        "key": "clubId",
        "type": "reference",
        "ref": "membership.member_club",
        "header": "md.fields.club_id"
      },
      {
        "key": "schemeId",
        "type": "reference",
        "ref": "membership.member_scheme",
        "header": "md.fields.scheme_id"
      },
      {
        "key": "pointsBalance",
        "type": "decimal",
        "header": "md.fields.points_balance"
      },
      {
        "key": "tierPoints",
        "type": "decimal",
        "header": "md.fields.tier_points"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "joinedAt",
        "type": "datetime",
        "header": "md.fields.joined_at"
      }
    ],
    "fields": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "required": true,
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "schemeId",
        "label": "md.fields.scheme_id",
        "required": false,
        "type": "reference",
        "ref": "membership.member_scheme"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      }
    ],
    "empty": {
      "clubId": null,
      "schemeId": null,
      "status": "active"
    },
    "children": [],
    "filters": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "schemeId",
        "label": "md.fields.scheme_id",
        "type": "reference",
        "ref": "membership.member_scheme"
      },
      {
        "key": "schemeSince",
        "label": "md.fields.scheme_since",
        "type": "datetime"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "closed",
            "label": "md.enums.status.closed"
          }
        ]
      },
      {
        "key": "joinedAt",
        "label": "md.fields.joined_at",
        "type": "datetime"
      },
      {
        "key": "joinedStoreId",
        "label": "md.fields.joined_store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "route": "/loyalty/accounts",
    "group": "loyalty"
  },
  "membership.member_contact": {
    "key": "membership.member_contact",
    "title": "md.resources.membership_member_contact",
    "path": "/api/v1/membership/contacts",
    "readPermission": "ho.members.contacts.read",
    "writePermission": "ho.members.contacts.manage",
    "labelFields": [
      "contact_no",
      "name"
    ],
    "columns": [
      {
        "key": "contactNo",
        "type": "text",
        "header": "md.fields.contact_no"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "phoneNormalized",
        "type": "text",
        "header": "md.fields.phone_normalized"
      },
      {
        "key": "clubId",
        "type": "reference",
        "ref": "membership.member_club",
        "header": "md.fields.club_id"
      },
      {
        "key": "accountNo",
        "type": "text",
        "header": "md.fields.account_no"
      },
      {
        "key": "marketingConsent",
        "type": "toggle",
        "header": "md.fields.marketing_consent"
      }
    ],
    "fields": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "required": true,
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "accountId",
        "label": "md.fields.account_id",
        "required": false,
        "type": "reference",
        "ref": "membership.member_account"
      },
      {
        "key": "isMain",
        "label": "md.fields.is_main",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "phoneNormalized",
        "label": "md.fields.phone_normalized",
        "required": true,
        "type": "text"
      },
      {
        "key": "email",
        "label": "md.fields.email",
        "required": false,
        "type": "text"
      },
      {
        "key": "birthDate",
        "label": "md.fields.birth_date",
        "required": false,
        "type": "date"
      },
      {
        "key": "gender",
        "label": "md.fields.gender",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "female",
            "label": "md.enums.gender.female"
          },
          {
            "value": "male",
            "label": "md.enums.gender.male"
          },
          {
            "value": "other",
            "label": "md.enums.gender.other"
          }
        ]
      },
      {
        "key": "marketingConsent",
        "label": "md.fields.marketing_consent",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "clubId": null,
      "accountId": null,
      "isMain": true,
      "name": "",
      "phoneNormalized": "",
      "email": null,
      "birthDate": null,
      "gender": null,
      "marketingConsent": false
    },
    "children": [],
    "filters": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "accountId",
        "label": "md.fields.account_id",
        "type": "reference",
        "ref": "membership.member_account"
      },
      {
        "key": "isMain",
        "label": "md.fields.is_main",
        "type": "toggle"
      },
      {
        "key": "birthDate",
        "label": "md.fields.birth_date",
        "type": "date"
      },
      {
        "key": "gender",
        "label": "md.fields.gender",
        "type": "select",
        "options": [
          {
            "value": "female",
            "label": "md.enums.gender.female"
          },
          {
            "value": "male",
            "label": "md.enums.gender.male"
          },
          {
            "value": "other",
            "label": "md.enums.gender.other"
          }
        ]
      },
      {
        "key": "marketingConsent",
        "label": "md.fields.marketing_consent",
        "type": "toggle"
      },
      {
        "key": "consentAt",
        "label": "md.fields.consent_at",
        "type": "datetime"
      }
    ],
    "route": "/loyalty/contacts",
    "group": "loyalty",
    "tabOf": [
      {
        "parent": "membership.member_account",
        "field": "accountId"
      }
    ]
  },
  "membership.member_card": {
    "key": "membership.member_card",
    "title": "md.resources.membership_member_card",
    "path": "/api/v1/membership/cards",
    "readPermission": "ho.members.cards.read",
    "writePermission": "ho.members.cards.manage",
    "labelFields": [
      "card_no"
    ],
    "columns": [
      {
        "key": "cardNo",
        "type": "text",
        "header": "md.fields.card_no"
      },
      {
        "key": "clubId",
        "type": "reference",
        "ref": "membership.member_club",
        "header": "md.fields.club_id"
      },
      {
        "key": "accountNo",
        "type": "text",
        "header": "md.fields.account_no"
      },
      {
        "key": "contactNo",
        "type": "text",
        "header": "md.fields.contact_no"
      },
      {
        "key": "isFree",
        "type": "toggle",
        "header": "md.fields.is_free"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "lost",
            "label": "md.enums.status.lost"
          }
        ],
        "header": "md.fields.status"
      }
    ],
    "fields": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "required": true,
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "accountId",
        "label": "md.fields.account_id",
        "required": false,
        "type": "reference",
        "ref": "membership.member_account"
      },
      {
        "key": "contactId",
        "label": "md.fields.contact_id",
        "required": false,
        "type": "reference",
        "ref": "membership.member_contact"
      },
      {
        "key": "cardNo",
        "label": "md.fields.card_no",
        "required": true,
        "type": "text"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "lost",
            "label": "md.enums.status.lost"
          }
        ]
      }
    ],
    "empty": {
      "clubId": null,
      "accountId": null,
      "contactId": null,
      "cardNo": "",
      "status": "active"
    },
    "children": [],
    "filters": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "accountId",
        "label": "md.fields.account_id",
        "type": "reference",
        "ref": "membership.member_account"
      },
      {
        "key": "contactId",
        "label": "md.fields.contact_id",
        "type": "reference",
        "ref": "membership.member_contact"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "blocked",
            "label": "md.enums.status.blocked"
          },
          {
            "value": "lost",
            "label": "md.enums.status.lost"
          }
        ]
      },
      {
        "key": "isFree",
        "label": "md.fields.is_free",
        "type": "toggle"
      }
    ],
    "route": "/loyalty/cards",
    "group": "loyalty",
    "tabOf": [
      {
        "parent": "membership.member_account",
        "field": "accountId"
      },
      {
        "parent": "membership.member_contact",
        "field": "contactId"
      }
    ]
  },
  "promotions.promotion": {
    "key": "promotions.promotion",
    "title": "md.resources.promotions_promotion",
    "path": "/api/v1/promotions/promotions",
    "readPermission": "ho.promotions.read",
    "writePermission": "ho.promotions.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "rewardMethod",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.reward_method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.reward_method.amount"
          }
        ],
        "header": "md.fields.reward_method"
      },
      {
        "key": "rewardValue",
        "type": "decimal",
        "header": "md.fields.reward_value"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "rewardMethod",
        "label": "md.fields.reward_method",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.reward_method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.reward_method.amount"
          }
        ]
      },
      {
        "key": "rewardValue",
        "label": "md.fields.reward_value",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "rewardScope",
        "label": "md.fields.reward_scope",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "order",
            "label": "md.enums.reward_scope.order"
          },
          {
            "value": "line",
            "label": "md.enums.reward_scope.line"
          }
        ]
      },
      {
        "key": "maxDiscount",
        "label": "md.fields.max_discount",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "rules",
        "label": "md.fields.rules",
        "required": false,
        "type": "json"
      },
      {
        "key": "isStackable",
        "label": "md.fields.is_stackable",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "fundedBy",
        "label": "md.fields.funded_by",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "brand",
            "label": "md.enums.funded_by.brand"
          },
          {
            "value": "store",
            "label": "md.enums.funded_by.store"
          },
          {
            "value": "partner",
            "label": "md.enums.funded_by.partner"
          }
        ]
      },
      {
        "key": "audience",
        "label": "md.fields.audience",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "anyone",
            "label": "md.enums.audience.anyone"
          },
          {
            "value": "members",
            "label": "md.enums.audience.members"
          },
          {
            "value": "holder",
            "label": "md.enums.audience.holder"
          },
          {
            "value": "segment",
            "label": "md.enums.audience.segment"
          }
        ]
      },
      {
        "key": "audienceSegmentId",
        "label": "md.fields.audience_segment_id",
        "required": false,
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ]
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "rewardMethod": "",
      "rewardValue": null,
      "rewardScope": "order",
      "maxDiscount": null,
      "rules": "{}",
      "isStackable": false,
      "fundedBy": "brand",
      "audience": "anyone",
      "audienceSegmentId": null,
      "validFrom": null,
      "validTo": null,
      "status": "draft"
    },
    "children": [
      "promotions.coupon_batch",
      "promotions.coupon"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "rewardMethod",
        "label": "md.fields.reward_method",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.reward_method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.reward_method.amount"
          }
        ]
      },
      {
        "key": "rewardScope",
        "label": "md.fields.reward_scope",
        "type": "select",
        "options": [
          {
            "value": "order",
            "label": "md.enums.reward_scope.order"
          },
          {
            "value": "line",
            "label": "md.enums.reward_scope.line"
          }
        ]
      },
      {
        "key": "isStackable",
        "label": "md.fields.is_stackable",
        "type": "toggle"
      },
      {
        "key": "fundedBy",
        "label": "md.fields.funded_by",
        "type": "select",
        "options": [
          {
            "value": "brand",
            "label": "md.enums.funded_by.brand"
          },
          {
            "value": "store",
            "label": "md.enums.funded_by.store"
          },
          {
            "value": "partner",
            "label": "md.enums.funded_by.partner"
          }
        ]
      },
      {
        "key": "audience",
        "label": "md.fields.audience",
        "type": "select",
        "options": [
          {
            "value": "anyone",
            "label": "md.enums.audience.anyone"
          },
          {
            "value": "members",
            "label": "md.enums.audience.members"
          },
          {
            "value": "holder",
            "label": "md.enums.audience.holder"
          },
          {
            "value": "segment",
            "label": "md.enums.audience.segment"
          }
        ]
      },
      {
        "key": "audienceSegmentId",
        "label": "md.fields.audience_segment_id",
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ]
      }
    ],
    "route": "/promotions/promotions",
    "group": "promotions"
  },
  "promotions.coupon_batch": {
    "key": "promotions.coupon_batch",
    "title": "md.resources.promotions_coupon_batch",
    "path": "/api/v1/promotions/promotions/{parentId}/batches",
    "readPermission": "ho.promotions.read",
    "writePermission": "ho.promotions.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "prefix",
        "type": "text",
        "header": "md.fields.prefix"
      },
      {
        "key": "quantity",
        "type": "number",
        "header": "md.fields.quantity"
      },
      {
        "key": "maxUses",
        "type": "number",
        "header": "md.fields.max_uses"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "prefix",
        "label": "md.fields.prefix",
        "required": false,
        "type": "text"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": true,
        "type": "number"
      },
      {
        "key": "maxUses",
        "label": "md.fields.max_uses",
        "required": false,
        "type": "number"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      }
    ],
    "empty": {
      "prefix": null,
      "quantity": null,
      "maxUses": null,
      "validFrom": null,
      "validTo": null
    },
    "children": [],
    "filters": [
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      }
    ],
    "parent": "promotions.promotion",
    "lookupPath": "/api/v1/promotions/coupon-batches"
  },
  "promotions.coupon": {
    "key": "promotions.coupon",
    "title": "md.resources.promotions_coupon",
    "path": "/api/v1/promotions/promotions/{parentId}/coupons",
    "readPermission": "ho.promotions.read",
    "writePermission": "ho.promotions.manage",
    "labelFields": [
      "code"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "maxUses",
        "type": "number",
        "header": "md.fields.max_uses"
      },
      {
        "key": "usesConfirmed",
        "type": "number",
        "header": "md.fields.uses_confirmed"
      },
      {
        "key": "usesReserved",
        "type": "number",
        "header": "md.fields.uses_reserved"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "maxUses",
        "label": "md.fields.max_uses",
        "required": false,
        "type": "number"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ]
      }
    ],
    "empty": {
      "code": "",
      "maxUses": null,
      "validFrom": null,
      "validTo": null,
      "status": "active"
    },
    "children": [],
    "filters": [
      {
        "key": "batchId",
        "label": "md.fields.batch_id",
        "type": "reference",
        "ref": "promotions.coupon_batch"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ]
      },
      {
        "key": "memberAccountId",
        "label": "md.fields.member_account_id",
        "type": "reference",
        "ref": "membership.member_account"
      }
    ],
    "parent": "promotions.promotion"
  },
  "membership.gift_voucher_batch": {
    "key": "membership.gift_voucher_batch",
    "title": "md.resources.membership_gift_voucher_batch",
    "path": "/api/v1/membership/gift-voucher-batches",
    "readPermission": "ho.vouchers.read",
    "writePermission": "ho.vouchers.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "faceValue",
        "type": "decimal",
        "header": "md.fields.face_value"
      },
      {
        "key": "quantity",
        "type": "number",
        "header": "md.fields.quantity"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "faceValue",
        "label": "md.fields.face_value",
        "required": true,
        "type": "decimal"
      },
      {
        "key": "currencyCode",
        "label": "md.fields.currency_code",
        "required": false,
        "type": "text"
      },
      {
        "key": "quantity",
        "label": "md.fields.quantity",
        "required": true,
        "type": "number"
      },
      {
        "key": "prefix",
        "label": "md.fields.prefix",
        "required": false,
        "type": "text"
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "rules",
        "label": "md.fields.rules",
        "required": false,
        "type": "json"
      },
      {
        "key": "audience",
        "label": "md.fields.audience",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "anyone",
            "label": "md.enums.audience.anyone"
          },
          {
            "value": "members",
            "label": "md.enums.audience.members"
          },
          {
            "value": "holder",
            "label": "md.enums.audience.holder"
          },
          {
            "value": "segment",
            "label": "md.enums.audience.segment"
          }
        ]
      },
      {
        "key": "audienceSegmentId",
        "label": "md.fields.audience_segment_id",
        "required": false,
        "type": "reference",
        "ref": "crm.segment"
      }
    ],
    "empty": {
      "name": "",
      "faceValue": null,
      "currencyCode": "VND",
      "quantity": null,
      "prefix": null,
      "validFrom": null,
      "validTo": null,
      "rules": "{}",
      "audience": "anyone",
      "audienceSegmentId": null
    },
    "children": [
      "membership.gift_voucher"
    ],
    "filters": [
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "audience",
        "label": "md.fields.audience",
        "type": "select",
        "options": [
          {
            "value": "anyone",
            "label": "md.enums.audience.anyone"
          },
          {
            "value": "members",
            "label": "md.enums.audience.members"
          },
          {
            "value": "holder",
            "label": "md.enums.audience.holder"
          },
          {
            "value": "segment",
            "label": "md.enums.audience.segment"
          }
        ]
      },
      {
        "key": "audienceSegmentId",
        "label": "md.fields.audience_segment_id",
        "type": "reference",
        "ref": "crm.segment"
      }
    ],
    "route": "/promotions/gift-voucher-batches",
    "group": "promotions"
  },
  "membership.gift_voucher": {
    "key": "membership.gift_voucher",
    "title": "md.resources.membership_gift_voucher",
    "path": "/api/v1/membership/gift-voucher-batches/{parentId}/vouchers",
    "readPermission": "ho.vouchers.read",
    "writePermission": "ho.vouchers.manage",
    "labelFields": [
      "code"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "faceValue",
        "type": "decimal",
        "header": "md.fields.face_value"
      },
      {
        "key": "balance",
        "type": "decimal",
        "header": "md.fields.balance"
      },
      {
        "key": "balanceReserved",
        "type": "decimal",
        "header": "md.fields.balance_reserved"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ]
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      }
    ],
    "empty": {
      "status": "active",
      "validFrom": null,
      "validTo": null
    },
    "children": [],
    "filters": [
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "used_up",
            "label": "md.enums.status.used_up"
          },
          {
            "value": "expired",
            "label": "md.enums.status.expired"
          },
          {
            "value": "cancelled",
            "label": "md.enums.status.cancelled"
          }
        ]
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "memberAccountId",
        "label": "md.fields.member_account_id",
        "type": "reference",
        "ref": "membership.member_account"
      }
    ],
    "parent": "membership.gift_voucher_batch"
  },
  "membership.reward_program": {
    "key": "membership.reward_program",
    "title": "md.resources.membership_reward_program",
    "path": "/api/v1/membership/reward-programs",
    "readPermission": "ho.members.reward_programs.read",
    "writePermission": "ho.members.reward_programs.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "clubId",
        "type": "reference",
        "ref": "membership.member_club",
        "header": "md.fields.club_id"
      },
      {
        "key": "triggerType",
        "type": "text",
        "header": "md.fields.trigger_type"
      },
      {
        "key": "rewardType",
        "type": "text",
        "header": "md.fields.reward_type"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "validTo",
        "type": "datetime",
        "header": "md.fields.valid_to"
      }
    ],
    "fields": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "required": true,
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "description",
        "label": "md.fields.description",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ]
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "required": false,
        "type": "datetime"
      },
      {
        "key": "triggerType",
        "label": "md.fields.trigger_type",
        "required": true,
        "type": "text"
      },
      {
        "key": "triggerSettings",
        "label": "md.fields.trigger_settings",
        "required": false,
        "type": "json"
      },
      {
        "key": "conditions",
        "label": "md.fields.conditions",
        "required": false,
        "type": "json"
      },
      {
        "key": "segmentId",
        "label": "md.fields.segment_id",
        "required": false,
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "rewardType",
        "label": "md.fields.reward_type",
        "required": true,
        "type": "text"
      },
      {
        "key": "rewardSettings",
        "label": "md.fields.reward_settings",
        "required": false,
        "type": "json"
      },
      {
        "key": "perMemberLimit",
        "label": "md.fields.per_member_limit",
        "required": false,
        "type": "number"
      },
      {
        "key": "notify",
        "label": "md.fields.notify",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "clubId": null,
      "code": "",
      "name": "",
      "description": null,
      "status": "draft",
      "validFrom": null,
      "validTo": null,
      "triggerType": "",
      "triggerSettings": "{}",
      "conditions": "{}",
      "segmentId": null,
      "rewardType": "",
      "rewardSettings": "{}",
      "perMemberLimit": null,
      "notify": true
    },
    "children": [],
    "filters": [
      {
        "key": "clubId",
        "label": "md.fields.club_id",
        "type": "reference",
        "ref": "membership.member_club"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          },
          {
            "value": "ended",
            "label": "md.enums.status.ended"
          }
        ]
      },
      {
        "key": "validFrom",
        "label": "md.fields.valid_from",
        "type": "datetime"
      },
      {
        "key": "validTo",
        "label": "md.fields.valid_to",
        "type": "datetime"
      },
      {
        "key": "segmentId",
        "label": "md.fields.segment_id",
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "notify",
        "label": "md.fields.notify",
        "type": "toggle"
      }
    ],
    "route": "/loyalty/reward-programs",
    "group": "loyalty"
  },
  "crm.segment": {
    "key": "crm.segment",
    "title": "md.resources.crm_segment",
    "path": "/api/v1/crm/segments",
    "readPermission": "ho.crm.read",
    "writePermission": "ho.crm.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "kind",
        "type": "select",
        "options": [
          {
            "value": "rules",
            "label": "md.enums.kind.rules"
          },
          {
            "value": "list",
            "label": "md.enums.kind.list"
          },
          {
            "value": "combined",
            "label": "md.enums.kind.combined"
          }
        ],
        "header": "md.fields.kind"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "memberCount",
        "type": "number",
        "header": "md.fields.member_count"
      },
      {
        "key": "lastRunAt",
        "type": "datetime",
        "header": "md.fields.last_run_at"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "description",
        "label": "md.fields.description",
        "required": false,
        "type": "textarea"
      },
      {
        "key": "kind",
        "label": "md.fields.kind",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "rules",
            "label": "md.enums.kind.rules"
          },
          {
            "value": "list",
            "label": "md.enums.kind.list"
          },
          {
            "value": "combined",
            "label": "md.enums.kind.combined"
          }
        ]
      },
      {
        "key": "conditions",
        "label": "md.fields.conditions",
        "required": false,
        "type": "json"
      },
      {
        "key": "combineMatch",
        "label": "md.fields.combine_match",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "all",
            "label": "md.enums.combine_match.all"
          },
          {
            "value": "any",
            "label": "md.enums.combine_match.any"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          }
        ]
      }
    ],
    "empty": {
      "code": "",
      "name": "",
      "nameI18n": {},
      "description": null,
      "kind": "rules",
      "conditions": "{}",
      "combineMatch": "all",
      "status": "active"
    },
    "children": [
      "crm.segment_part"
    ],
    "filters": [
      {
        "key": "kind",
        "label": "md.fields.kind",
        "type": "select",
        "options": [
          {
            "value": "rules",
            "label": "md.enums.kind.rules"
          },
          {
            "value": "list",
            "label": "md.enums.kind.list"
          },
          {
            "value": "combined",
            "label": "md.enums.kind.combined"
          }
        ]
      },
      {
        "key": "combineMatch",
        "label": "md.fields.combine_match",
        "type": "select",
        "options": [
          {
            "value": "all",
            "label": "md.enums.combine_match.all"
          },
          {
            "value": "any",
            "label": "md.enums.combine_match.any"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "paused",
            "label": "md.enums.status.paused"
          }
        ]
      },
      {
        "key": "lastRunAt",
        "label": "md.fields.last_run_at",
        "type": "datetime"
      },
      {
        "key": "refreshRequestedAt",
        "label": "md.fields.refresh_requested_at",
        "type": "datetime"
      }
    ],
    "route": "/marketing/segments",
    "group": "marketing"
  },
  "crm.segment_part": {
    "key": "crm.segment_part",
    "title": "md.resources.crm_segment_part",
    "path": "/api/v1/crm/segments/{parentId}/parts",
    "readPermission": "ho.crm.read",
    "writePermission": "ho.crm.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "partSegmentId",
        "type": "reference",
        "ref": "crm.segment",
        "header": "md.fields.part_segment_id"
      },
      {
        "key": "partRole",
        "type": "select",
        "options": [
          {
            "value": "include",
            "label": "md.enums.part_role.include"
          },
          {
            "value": "exclude",
            "label": "md.enums.part_role.exclude"
          }
        ],
        "header": "md.fields.part_role"
      }
    ],
    "fields": [
      {
        "key": "partSegmentId",
        "label": "md.fields.part_segment_id",
        "required": true,
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "partRole",
        "label": "md.fields.part_role",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "include",
            "label": "md.enums.part_role.include"
          },
          {
            "value": "exclude",
            "label": "md.enums.part_role.exclude"
          }
        ]
      }
    ],
    "empty": {
      "partSegmentId": null,
      "partRole": "include"
    },
    "children": [],
    "filters": [
      {
        "key": "partSegmentId",
        "label": "md.fields.part_segment_id",
        "type": "reference",
        "ref": "crm.segment"
      },
      {
        "key": "partRole",
        "label": "md.fields.part_role",
        "type": "select",
        "options": [
          {
            "value": "include",
            "label": "md.enums.part_role.include"
          },
          {
            "value": "exclude",
            "label": "md.enums.part_role.exclude"
          }
        ]
      }
    ],
    "parent": "crm.segment"
  },
  "cms.page": {
    "key": "cms.page",
    "title": "md.resources.cms_page",
    "path": "/api/v1/cms/pages",
    "readPermission": "ho.content.read",
    "writePermission": "ho.content.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "kind",
        "type": "select",
        "options": [
          {
            "value": "site",
            "label": "md.enums.kind.site"
          },
          {
            "value": "home",
            "label": "md.enums.kind.home"
          },
          {
            "value": "page",
            "label": "md.enums.kind.page"
          },
          {
            "value": "promotion",
            "label": "md.enums.kind.promotion"
          },
          {
            "value": "news",
            "label": "md.enums.kind.news"
          },
          {
            "value": "form",
            "label": "md.enums.kind.form"
          }
        ],
        "header": "md.fields.kind"
      },
      {
        "key": "slug",
        "type": "text",
        "header": "md.fields.slug"
      },
      {
        "key": "titleI18n",
        "type": "localized",
        "header": "md.fields.title_i18n"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "published",
            "label": "md.enums.status.published"
          },
          {
            "value": "unpublished",
            "label": "md.enums.status.unpublished"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "hasChanges",
        "type": "toggle",
        "header": "md.fields.has_changes"
      },
      {
        "key": "publishedAt",
        "type": "datetime",
        "header": "md.fields.published_at"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": true,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "kind",
        "label": "md.fields.kind",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "site",
            "label": "md.enums.kind.site"
          },
          {
            "value": "home",
            "label": "md.enums.kind.home"
          },
          {
            "value": "page",
            "label": "md.enums.kind.page"
          },
          {
            "value": "promotion",
            "label": "md.enums.kind.promotion"
          },
          {
            "value": "news",
            "label": "md.enums.kind.news"
          },
          {
            "value": "form",
            "label": "md.enums.kind.form"
          }
        ]
      },
      {
        "key": "slug",
        "label": "md.fields.slug",
        "required": true,
        "type": "text"
      },
      {
        "key": "titleI18n",
        "label": "md.fields.title_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "summaryI18n",
        "label": "md.fields.summary_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "coverUrl",
        "label": "md.fields.cover_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "seoTitleI18n",
        "label": "md.fields.seo_title_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "seoDescriptionI18n",
        "label": "md.fields.seo_description_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "ogImageUrl",
        "label": "md.fields.og_image_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "content",
        "label": "md.fields.content",
        "required": false,
        "type": "json"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "brandId": null,
      "kind": "",
      "slug": "",
      "titleI18n": {},
      "summaryI18n": {},
      "coverUrl": null,
      "seoTitleI18n": {},
      "seoDescriptionI18n": {},
      "ogImageUrl": null,
      "content": "{}",
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "kind",
        "label": "md.fields.kind",
        "type": "select",
        "options": [
          {
            "value": "site",
            "label": "md.enums.kind.site"
          },
          {
            "value": "home",
            "label": "md.enums.kind.home"
          },
          {
            "value": "page",
            "label": "md.enums.kind.page"
          },
          {
            "value": "promotion",
            "label": "md.enums.kind.promotion"
          },
          {
            "value": "news",
            "label": "md.enums.kind.news"
          },
          {
            "value": "form",
            "label": "md.enums.kind.form"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "draft",
            "label": "md.enums.status.draft"
          },
          {
            "value": "published",
            "label": "md.enums.status.published"
          },
          {
            "value": "unpublished",
            "label": "md.enums.status.unpublished"
          }
        ]
      },
      {
        "key": "publishedAt",
        "label": "md.fields.published_at",
        "type": "datetime"
      },
      {
        "key": "hasChanges",
        "label": "md.fields.has_changes",
        "type": "toggle"
      }
    ],
    "route": "/cms/pages",
    "group": "cms"
  },
  "config.discount_preset": {
    "key": "config.discount_preset",
    "title": "md.resources.config_discount_preset",
    "path": "/api/v1/menu/config/discount-presets",
    "readPermission": "ho.config.discount_presets.read",
    "writePermission": "ho.config.discount_presets.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "method",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.method.amount"
          }
        ],
        "header": "md.fields.method"
      },
      {
        "key": "scope",
        "type": "select",
        "options": [
          {
            "value": "order",
            "label": "md.enums.scope.order"
          },
          {
            "value": "line",
            "label": "md.enums.scope.line"
          },
          {
            "value": "both",
            "label": "md.enums.scope.both"
          }
        ],
        "header": "md.fields.scope"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "value",
        "type": "decimal",
        "header": "md.fields.value"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "method",
        "label": "md.fields.method",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.method.amount"
          }
        ]
      },
      {
        "key": "value",
        "label": "md.fields.value",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "maxValue",
        "label": "md.fields.max_value",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "scope",
        "label": "md.fields.scope",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "order",
            "label": "md.enums.scope.order"
          },
          {
            "value": "line",
            "label": "md.enums.scope.line"
          },
          {
            "value": "both",
            "label": "md.enums.scope.both"
          }
        ]
      },
      {
        "key": "requiresApproval",
        "label": "md.fields.requires_approval",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "reasonRequired",
        "label": "md.fields.reason_required",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "appliesAfterTax",
        "label": "md.fields.applies_after_tax",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "rules",
        "label": "md.fields.rules",
        "required": false,
        "type": "json"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "name": "",
      "method": "",
      "value": null,
      "maxValue": null,
      "scope": "",
      "requiresApproval": false,
      "reasonRequired": false,
      "appliesAfterTax": false,
      "rules": "{}",
      "sortOrder": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "method",
        "label": "md.fields.method",
        "type": "select",
        "options": [
          {
            "value": "percent",
            "label": "md.enums.method.percent"
          },
          {
            "value": "amount",
            "label": "md.enums.method.amount"
          }
        ]
      },
      {
        "key": "scope",
        "label": "md.fields.scope",
        "type": "select",
        "options": [
          {
            "value": "order",
            "label": "md.enums.scope.order"
          },
          {
            "value": "line",
            "label": "md.enums.scope.line"
          },
          {
            "value": "both",
            "label": "md.enums.scope.both"
          }
        ]
      },
      {
        "key": "requiresApproval",
        "label": "md.fields.requires_approval",
        "type": "toggle"
      },
      {
        "key": "reasonRequired",
        "label": "md.fields.reason_required",
        "type": "toggle"
      },
      {
        "key": "appliesAfterTax",
        "label": "md.fields.applies_after_tax",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/pos/discount-presets",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.reason_code": {
    "key": "config.reason_code",
    "title": "md.resources.config_reason_code",
    "path": "/api/v1/menu/config/reason-codes",
    "readPermission": "ho.config.reason_codes.read",
    "writePermission": "ho.config.reason_codes.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "reasonType",
        "type": "select",
        "options": [
          {
            "value": "void",
            "label": "md.enums.reason_type.void"
          },
          {
            "value": "discount",
            "label": "md.enums.reason_type.discount"
          },
          {
            "value": "refund",
            "label": "md.enums.reason_type.refund"
          },
          {
            "value": "cash_movement",
            "label": "md.enums.reason_type.cash_movement"
          },
          {
            "value": "order_reject",
            "label": "md.enums.reason_type.order_reject"
          },
          {
            "value": "table_reset",
            "label": "md.enums.reason_type.table_reset"
          },
          {
            "value": "stock_adjustment",
            "label": "md.enums.reason_type.stock_adjustment"
          }
        ],
        "header": "md.fields.reason_type"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "reasonType",
        "label": "md.fields.reason_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "void",
            "label": "md.enums.reason_type.void"
          },
          {
            "value": "discount",
            "label": "md.enums.reason_type.discount"
          },
          {
            "value": "refund",
            "label": "md.enums.reason_type.refund"
          },
          {
            "value": "cash_movement",
            "label": "md.enums.reason_type.cash_movement"
          },
          {
            "value": "order_reject",
            "label": "md.enums.reason_type.order_reject"
          },
          {
            "value": "table_reset",
            "label": "md.enums.reason_type.table_reset"
          },
          {
            "value": "stock_adjustment",
            "label": "md.enums.reason_type.stock_adjustment"
          }
        ]
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "reasonType": "",
      "code": "",
      "name": "",
      "nameI18n": {},
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "reasonType",
        "label": "md.fields.reason_type",
        "type": "select",
        "options": [
          {
            "value": "void",
            "label": "md.enums.reason_type.void"
          },
          {
            "value": "discount",
            "label": "md.enums.reason_type.discount"
          },
          {
            "value": "refund",
            "label": "md.enums.reason_type.refund"
          },
          {
            "value": "cash_movement",
            "label": "md.enums.reason_type.cash_movement"
          },
          {
            "value": "order_reject",
            "label": "md.enums.reason_type.order_reject"
          },
          {
            "value": "table_reset",
            "label": "md.enums.reason_type.table_reset"
          },
          {
            "value": "stock_adjustment",
            "label": "md.enums.reason_type.stock_adjustment"
          }
        ]
      }
    ],
    "route": "/pos/reason-codes",
    "group": "pos"
  },
  "config.prompt": {
    "key": "config.prompt",
    "title": "md.resources.config_prompt",
    "path": "/api/v1/menu/config/prompts",
    "readPermission": "ho.config.prompts.read",
    "writePermission": "ho.config.prompts.manage",
    "labelFields": [
      "code",
      "question"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "question",
        "type": "text",
        "header": "md.fields.question"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "question",
        "label": "md.fields.question",
        "required": true,
        "type": "text"
      },
      {
        "key": "questionI18n",
        "label": "md.fields.question_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "minSelect",
        "label": "md.fields.min_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "maxSelect",
        "label": "md.fields.max_select",
        "required": false,
        "type": "number"
      },
      {
        "key": "isSkippable",
        "label": "md.fields.is_skippable",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "question": "",
      "questionI18n": {},
      "minSelect": 1,
      "maxSelect": 1,
      "isSkippable": false
    },
    "children": [
      "config.prompt_answer",
      "config.prompt_trigger"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "isSkippable",
        "label": "md.fields.is_skippable",
        "type": "toggle"
      }
    ],
    "route": "/pos/prompts",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.prompt_answer": {
    "key": "config.prompt_answer",
    "title": "md.resources.config_prompt_answer",
    "path": "/api/v1/menu/config/prompts/{parentId}/answers",
    "readPermission": "ho.config.prompts.read",
    "writePermission": "ho.config.prompts.manage",
    "labelFields": [
      "code",
      "label"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "label",
        "type": "text",
        "header": "md.fields.label"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "label",
        "label": "md.fields.label",
        "required": true,
        "type": "text"
      },
      {
        "key": "labelI18n",
        "label": "md.fields.label_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "code": "",
      "label": "",
      "labelI18n": {},
      "sortOrder": 0
    },
    "children": [],
    "filters": [],
    "parent": "config.prompt"
  },
  "config.prompt_trigger": {
    "key": "config.prompt_trigger",
    "title": "md.resources.config_prompt_trigger",
    "path": "/api/v1/menu/config/prompts/{parentId}/triggers",
    "readPermission": "ho.config.prompts.read",
    "writePermission": "ho.config.prompts.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "triggerEvent",
        "type": "select",
        "options": [
          {
            "value": "order_start",
            "label": "md.enums.trigger_event.order_start"
          },
          {
            "value": "item_added",
            "label": "md.enums.trigger_event.item_added"
          },
          {
            "value": "before_payment",
            "label": "md.enums.trigger_event.before_payment"
          }
        ],
        "header": "md.fields.trigger_event"
      },
      {
        "key": "saleTypeId",
        "type": "reference",
        "ref": "config.sale_type",
        "header": "md.fields.sale_type_id"
      },
      {
        "key": "posProfileId",
        "type": "reference",
        "ref": "config.pos_profile",
        "header": "md.fields.pos_profile_id"
      }
    ],
    "fields": [
      {
        "key": "triggerEvent",
        "label": "md.fields.trigger_event",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "order_start",
            "label": "md.enums.trigger_event.order_start"
          },
          {
            "value": "item_added",
            "label": "md.enums.trigger_event.item_added"
          },
          {
            "value": "before_payment",
            "label": "md.enums.trigger_event.before_payment"
          }
        ]
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "required": false,
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "itemCategoryId",
        "label": "md.fields.item_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item_category"
      }
    ],
    "empty": {
      "triggerEvent": "",
      "saleTypeId": null,
      "posProfileId": null,
      "itemCategoryId": null
    },
    "children": [],
    "filters": [
      {
        "key": "triggerEvent",
        "label": "md.fields.trigger_event",
        "type": "select",
        "options": [
          {
            "value": "order_start",
            "label": "md.enums.trigger_event.order_start"
          },
          {
            "value": "item_added",
            "label": "md.enums.trigger_event.item_added"
          },
          {
            "value": "before_payment",
            "label": "md.enums.trigger_event.before_payment"
          }
        ]
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "itemCategoryId",
        "label": "md.fields.item_category_id",
        "type": "reference",
        "ref": "catalog.item_category"
      }
    ],
    "parent": "config.prompt"
  },
  "config.document_template": {
    "key": "config.document_template",
    "title": "md.resources.config_document_template",
    "path": "/api/v1/menu/config/templates",
    "readPermission": "ho.config.templates.read",
    "writePermission": "ho.config.templates.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "documentType",
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ],
        "header": "md.fields.document_type"
      },
      {
        "key": "engine",
        "type": "select",
        "options": [
          {
            "value": "scriban",
            "label": "md.enums.engine.scriban"
          },
          {
            "value": "text",
            "label": "md.enums.engine.text"
          }
        ],
        "header": "md.fields.engine"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      }
    ],
    "fields": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "documentType",
        "label": "md.fields.document_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ]
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "engine",
        "label": "md.fields.engine",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "scriban",
            "label": "md.enums.engine.scriban"
          },
          {
            "value": "text",
            "label": "md.enums.engine.text"
          }
        ]
      },
      {
        "key": "paperWidthMm",
        "label": "md.fields.paper_width_mm",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": 58,
            "label": "md.enums.paper_width_mm.58"
          },
          {
            "value": 80,
            "label": "md.enums.paper_width_mm.80"
          }
        ]
      },
      {
        "key": "language",
        "label": "md.fields.language",
        "required": false,
        "type": "text"
      },
      {
        "key": "body",
        "label": "md.fields.body",
        "required": true,
        "type": "textarea"
      }
    ],
    "empty": {
      "brandId": null,
      "code": "",
      "documentType": "",
      "name": "",
      "engine": "scriban",
      "paperWidthMm": 80,
      "language": "vi",
      "body": ""
    },
    "children": [
      "config.template_assignment"
    ],
    "filters": [
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "documentType",
        "label": "md.fields.document_type",
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ]
      },
      {
        "key": "engine",
        "label": "md.fields.engine",
        "type": "select",
        "options": [
          {
            "value": "scriban",
            "label": "md.enums.engine.scriban"
          },
          {
            "value": "text",
            "label": "md.enums.engine.text"
          }
        ]
      },
      {
        "key": "paperWidthMm",
        "label": "md.fields.paper_width_mm",
        "type": "select",
        "options": [
          {
            "value": 58,
            "label": "md.enums.paper_width_mm.58"
          },
          {
            "value": 80,
            "label": "md.enums.paper_width_mm.80"
          }
        ]
      }
    ],
    "route": "/pos/templates",
    "group": "pos",
    "fixedOnEdit": [
      "brandId"
    ]
  },
  "config.template_assignment": {
    "key": "config.template_assignment",
    "title": "md.resources.config_template_assignment",
    "path": "/api/v1/menu/config/templates/{parentId}/assignments",
    "readPermission": "ho.config.templates.read",
    "writePermission": "ho.config.templates.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "documentType",
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ],
        "header": "md.fields.document_type"
      },
      {
        "key": "brandId",
        "type": "reference",
        "ref": "org.brand",
        "header": "md.fields.brand_id"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "priority",
        "type": "number",
        "header": "md.fields.priority"
      }
    ],
    "fields": [
      {
        "key": "documentType",
        "label": "md.fields.document_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ]
      },
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "required": false,
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": false,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "priority",
        "label": "md.fields.priority",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "documentType": "",
      "brandId": null,
      "storeId": null,
      "saleTypeId": null,
      "priority": 0
    },
    "children": [],
    "filters": [
      {
        "key": "documentType",
        "label": "md.fields.document_type",
        "type": "select",
        "options": [
          {
            "value": "receipt",
            "label": "md.enums.document_type.receipt"
          },
          {
            "value": "bill",
            "label": "md.enums.document_type.bill"
          },
          {
            "value": "kitchen_ticket",
            "label": "md.enums.document_type.kitchen_ticket"
          },
          {
            "value": "delivery_slip",
            "label": "md.enums.document_type.delivery_slip"
          },
          {
            "value": "shift_report",
            "label": "md.enums.document_type.shift_report"
          },
          {
            "value": "day_report",
            "label": "md.enums.document_type.day_report"
          },
          {
            "value": "label",
            "label": "md.enums.document_type.label"
          }
        ]
      },
      {
        "key": "brandId",
        "label": "md.fields.brand_id",
        "type": "reference",
        "ref": "org.brand"
      },
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      }
    ],
    "parent": "config.document_template",
    "fixedOnEdit": [
      "brandId",
      "storeId"
    ]
  },
  "einvoice.einvoice_profile": {
    "key": "einvoice.einvoice_profile",
    "title": "md.resources.einvoice_einvoice_profile",
    "path": "/api/v1/einvoice/profiles",
    "readPermission": "ho.einvoice.read",
    "writePermission": "ho.einvoice.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "legalEntityId",
        "type": "reference",
        "ref": "org.legal_entity",
        "header": "md.fields.legal_entity_id"
      },
      {
        "key": "sellerTaxCode",
        "type": "text",
        "header": "md.fields.seller_tax_code"
      },
      {
        "key": "templateCode",
        "type": "text",
        "header": "md.fields.template_code"
      },
      {
        "key": "invoiceSeries",
        "type": "text",
        "header": "md.fields.invoice_series"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "legalEntityId",
        "label": "md.fields.legal_entity_id",
        "required": true,
        "type": "reference",
        "ref": "org.legal_entity"
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "required": true,
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "sellerTaxCode",
        "label": "md.fields.seller_tax_code",
        "required": true,
        "type": "text"
      },
      {
        "key": "templateCode",
        "label": "md.fields.template_code",
        "required": true,
        "type": "text"
      },
      {
        "key": "invoiceSeries",
        "label": "md.fields.invoice_series",
        "required": true,
        "type": "text"
      },
      {
        "key": "invoiceKind",
        "label": "md.fields.invoice_kind",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "vat",
            "label": "md.enums.invoice_kind.vat"
          },
          {
            "value": "sales",
            "label": "md.enums.invoice_kind.sales"
          }
        ]
      },
      {
        "key": "lineDetail",
        "label": "md.fields.line_detail",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "combined",
            "label": "md.enums.line_detail.combined"
          },
          {
            "value": "detailed",
            "label": "md.enums.line_detail.detailed"
          }
        ]
      },
      {
        "key": "holdMinutes",
        "label": "md.fields.hold_minutes",
        "required": false,
        "type": "number"
      },
      {
        "key": "sendBy",
        "label": "md.fields.send_by",
        "required": false,
        "type": "time"
      },
      {
        "key": "paymentMethodName",
        "label": "md.fields.payment_method_name",
        "required": false,
        "type": "text"
      },
      {
        "key": "emailBuyer",
        "label": "md.fields.email_buyer",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "legalEntityId": null,
      "providerAccountId": null,
      "code": "",
      "name": "",
      "sellerTaxCode": "",
      "templateCode": "",
      "invoiceSeries": "",
      "invoiceKind": "vat",
      "lineDetail": "combined",
      "holdMinutes": 60,
      "sendBy": "22:00",
      "paymentMethodName": "TM/CK",
      "emailBuyer": true,
      "isActive": true
    },
    "children": [
      "einvoice.profile_store"
    ],
    "filters": [
      {
        "key": "legalEntityId",
        "label": "md.fields.legal_entity_id",
        "type": "reference",
        "ref": "org.legal_entity"
      },
      {
        "key": "providerAccountId",
        "label": "md.fields.provider_account_id",
        "type": "reference",
        "ref": "integration.provider_account"
      },
      {
        "key": "invoiceKind",
        "label": "md.fields.invoice_kind",
        "type": "select",
        "options": [
          {
            "value": "vat",
            "label": "md.enums.invoice_kind.vat"
          },
          {
            "value": "sales",
            "label": "md.enums.invoice_kind.sales"
          }
        ]
      },
      {
        "key": "lineDetail",
        "label": "md.fields.line_detail",
        "type": "select",
        "options": [
          {
            "value": "combined",
            "label": "md.enums.line_detail.combined"
          },
          {
            "value": "detailed",
            "label": "md.enums.line_detail.detailed"
          }
        ]
      },
      {
        "key": "emailBuyer",
        "label": "md.fields.email_buyer",
        "type": "toggle"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/einvoice/profiles",
    "group": "einvoice"
  },
  "einvoice.profile_store": {
    "key": "einvoice.profile_store",
    "title": "md.resources.einvoice_profile_store",
    "path": "/api/v1/einvoice/profiles/{parentId}/stores",
    "readPermission": "ho.einvoice.read",
    "writePermission": "ho.einvoice.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "empty": {
      "storeId": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "parent": "einvoice.einvoice_profile"
  },
  "store.terminal": {
    "key": "store.terminal",
    "title": "md.resources.store_terminal",
    "path": "/api/v1/devices/terminals",
    "readPermission": "ho.devices.terminals.read",
    "writePermission": "ho.devices.terminals.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "terminalType",
        "type": "select",
        "options": [
          {
            "value": "fixed_pos",
            "label": "md.enums.terminal_type.fixed_pos"
          },
          {
            "value": "tablet",
            "label": "md.enums.terminal_type.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.terminal_type.handheld"
          },
          {
            "value": "kds",
            "label": "md.enums.terminal_type.kds"
          },
          {
            "value": "kiosk",
            "label": "md.enums.terminal_type.kiosk"
          }
        ],
        "header": "md.fields.terminal_type"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "pending",
            "label": "md.enums.status.pending"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "revoked",
            "label": "md.enums.status.revoked"
          }
        ],
        "header": "md.fields.status"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "posProfileId",
        "type": "reference",
        "ref": "config.pos_profile",
        "header": "md.fields.pos_profile_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "terminalType",
        "label": "md.fields.terminal_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "fixed_pos",
            "label": "md.enums.terminal_type.fixed_pos"
          },
          {
            "value": "tablet",
            "label": "md.enums.terminal_type.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.terminal_type.handheld"
          },
          {
            "value": "kds",
            "label": "md.enums.terminal_type.kds"
          },
          {
            "value": "kiosk",
            "label": "md.enums.terminal_type.kiosk"
          }
        ]
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "required": false,
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "settingsOverride",
        "label": "md.fields.settings_override",
        "required": false,
        "type": "json"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "pending",
            "label": "md.enums.status.pending"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "revoked",
            "label": "md.enums.status.revoked"
          }
        ]
      }
    ],
    "empty": {
      "storeId": null,
      "code": "",
      "name": "",
      "terminalType": "",
      "posProfileId": null,
      "settingsOverride": "{}",
      "status": "active"
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "terminalType",
        "label": "md.fields.terminal_type",
        "type": "select",
        "options": [
          {
            "value": "fixed_pos",
            "label": "md.enums.terminal_type.fixed_pos"
          },
          {
            "value": "tablet",
            "label": "md.enums.terminal_type.tablet"
          },
          {
            "value": "handheld",
            "label": "md.enums.terminal_type.handheld"
          },
          {
            "value": "kds",
            "label": "md.enums.terminal_type.kds"
          },
          {
            "value": "kiosk",
            "label": "md.enums.terminal_type.kiosk"
          }
        ]
      },
      {
        "key": "posProfileId",
        "label": "md.fields.pos_profile_id",
        "type": "reference",
        "ref": "config.pos_profile"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "pending",
            "label": "md.enums.status.pending"
          },
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "revoked",
            "label": "md.enums.status.revoked"
          }
        ]
      }
    ],
    "route": "/pos/terminals",
    "group": "pos",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.device": {
    "key": "store.device",
    "title": "md.resources.store_device",
    "path": "/api/v1/devices/devices",
    "readPermission": "ho.devices.devices.read",
    "writePermission": "ho.devices.devices.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "deviceType",
        "type": "select",
        "options": [
          {
            "value": "receipt_printer",
            "label": "md.enums.device_type.receipt_printer"
          },
          {
            "value": "kitchen_printer",
            "label": "md.enums.device_type.kitchen_printer"
          },
          {
            "value": "label_printer",
            "label": "md.enums.device_type.label_printer"
          },
          {
            "value": "cash_drawer",
            "label": "md.enums.device_type.cash_drawer"
          },
          {
            "value": "customer_display",
            "label": "md.enums.device_type.customer_display"
          },
          {
            "value": "scanner",
            "label": "md.enums.device_type.scanner"
          },
          {
            "value": "payment_terminal",
            "label": "md.enums.device_type.payment_terminal"
          },
          {
            "value": "kds_screen",
            "label": "md.enums.device_type.kds_screen"
          }
        ],
        "header": "md.fields.device_type"
      },
      {
        "key": "connectionType",
        "type": "select",
        "options": [
          {
            "value": "tcp",
            "label": "md.enums.connection_type.tcp"
          },
          {
            "value": "usb",
            "label": "md.enums.connection_type.usb"
          },
          {
            "value": "serial",
            "label": "md.enums.connection_type.serial"
          },
          {
            "value": "bluetooth",
            "label": "md.enums.connection_type.bluetooth"
          },
          {
            "value": "provider_sdk",
            "label": "md.enums.connection_type.provider_sdk"
          },
          {
            "value": "browser",
            "label": "md.enums.connection_type.browser"
          }
        ],
        "header": "md.fields.connection_type"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "terminalId",
        "type": "reference",
        "ref": "store.terminal",
        "header": "md.fields.terminal_id"
      },
      {
        "key": "status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          }
        ],
        "header": "md.fields.status"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "terminalId",
        "label": "md.fields.terminal_id",
        "required": false,
        "type": "reference",
        "ref": "store.terminal"
      },
      {
        "key": "deviceType",
        "label": "md.fields.device_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "receipt_printer",
            "label": "md.enums.device_type.receipt_printer"
          },
          {
            "value": "kitchen_printer",
            "label": "md.enums.device_type.kitchen_printer"
          },
          {
            "value": "label_printer",
            "label": "md.enums.device_type.label_printer"
          },
          {
            "value": "cash_drawer",
            "label": "md.enums.device_type.cash_drawer"
          },
          {
            "value": "customer_display",
            "label": "md.enums.device_type.customer_display"
          },
          {
            "value": "scanner",
            "label": "md.enums.device_type.scanner"
          },
          {
            "value": "payment_terminal",
            "label": "md.enums.device_type.payment_terminal"
          },
          {
            "value": "kds_screen",
            "label": "md.enums.device_type.kds_screen"
          }
        ]
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "connectionType",
        "label": "md.fields.connection_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "tcp",
            "label": "md.enums.connection_type.tcp"
          },
          {
            "value": "usb",
            "label": "md.enums.connection_type.usb"
          },
          {
            "value": "serial",
            "label": "md.enums.connection_type.serial"
          },
          {
            "value": "bluetooth",
            "label": "md.enums.connection_type.bluetooth"
          },
          {
            "value": "provider_sdk",
            "label": "md.enums.connection_type.provider_sdk"
          },
          {
            "value": "browser",
            "label": "md.enums.connection_type.browser"
          }
        ]
      },
      {
        "key": "address",
        "label": "md.fields.address",
        "required": false,
        "type": "text"
      },
      {
        "key": "port",
        "label": "md.fields.port",
        "required": false,
        "type": "number"
      },
      {
        "key": "model",
        "label": "md.fields.model",
        "required": false,
        "type": "text"
      },
      {
        "key": "settings",
        "label": "md.fields.settings",
        "required": false,
        "type": "json"
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          }
        ]
      }
    ],
    "empty": {
      "storeId": null,
      "terminalId": null,
      "deviceType": "",
      "name": "",
      "connectionType": "",
      "address": null,
      "port": null,
      "model": null,
      "settings": "{}",
      "status": "active"
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "terminalId",
        "label": "md.fields.terminal_id",
        "type": "reference",
        "ref": "store.terminal"
      },
      {
        "key": "deviceType",
        "label": "md.fields.device_type",
        "type": "select",
        "options": [
          {
            "value": "receipt_printer",
            "label": "md.enums.device_type.receipt_printer"
          },
          {
            "value": "kitchen_printer",
            "label": "md.enums.device_type.kitchen_printer"
          },
          {
            "value": "label_printer",
            "label": "md.enums.device_type.label_printer"
          },
          {
            "value": "cash_drawer",
            "label": "md.enums.device_type.cash_drawer"
          },
          {
            "value": "customer_display",
            "label": "md.enums.device_type.customer_display"
          },
          {
            "value": "scanner",
            "label": "md.enums.device_type.scanner"
          },
          {
            "value": "payment_terminal",
            "label": "md.enums.device_type.payment_terminal"
          },
          {
            "value": "kds_screen",
            "label": "md.enums.device_type.kds_screen"
          }
        ]
      },
      {
        "key": "connectionType",
        "label": "md.fields.connection_type",
        "type": "select",
        "options": [
          {
            "value": "tcp",
            "label": "md.enums.connection_type.tcp"
          },
          {
            "value": "usb",
            "label": "md.enums.connection_type.usb"
          },
          {
            "value": "serial",
            "label": "md.enums.connection_type.serial"
          },
          {
            "value": "bluetooth",
            "label": "md.enums.connection_type.bluetooth"
          },
          {
            "value": "provider_sdk",
            "label": "md.enums.connection_type.provider_sdk"
          },
          {
            "value": "browser",
            "label": "md.enums.connection_type.browser"
          }
        ]
      },
      {
        "key": "status",
        "label": "md.fields.status",
        "type": "select",
        "options": [
          {
            "value": "active",
            "label": "md.enums.status.active"
          },
          {
            "value": "inactive",
            "label": "md.enums.status.inactive"
          }
        ]
      }
    ],
    "route": "/pos/devices",
    "group": "pos",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.station": {
    "key": "store.station",
    "title": "md.resources.store_station",
    "path": "/api/v1/devices/stations",
    "readPermission": "ho.devices.stations.read",
    "writePermission": "ho.devices.stations.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "stationType",
        "type": "select",
        "options": [
          {
            "value": "kitchen",
            "label": "md.enums.station_type.kitchen"
          },
          {
            "value": "bar",
            "label": "md.enums.station_type.bar"
          },
          {
            "value": "pastry",
            "label": "md.enums.station_type.pastry"
          },
          {
            "value": "expo",
            "label": "md.enums.station_type.expo"
          },
          {
            "value": "other",
            "label": "md.enums.station_type.other"
          }
        ],
        "header": "md.fields.station_type"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "primaryDeviceId",
        "type": "reference",
        "ref": "store.device",
        "header": "md.fields.primary_device_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "stationType",
        "label": "md.fields.station_type",
        "required": true,
        "type": "select",
        "options": [
          {
            "value": "kitchen",
            "label": "md.enums.station_type.kitchen"
          },
          {
            "value": "bar",
            "label": "md.enums.station_type.bar"
          },
          {
            "value": "pastry",
            "label": "md.enums.station_type.pastry"
          },
          {
            "value": "expo",
            "label": "md.enums.station_type.expo"
          },
          {
            "value": "other",
            "label": "md.enums.station_type.other"
          }
        ]
      },
      {
        "key": "primaryDeviceId",
        "label": "md.fields.primary_device_id",
        "required": false,
        "type": "reference",
        "ref": "store.device"
      },
      {
        "key": "fallbackDeviceId",
        "label": "md.fields.fallback_device_id",
        "required": false,
        "type": "reference",
        "ref": "store.device"
      },
      {
        "key": "kdsEnabled",
        "label": "md.fields.kds_enabled",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "kdsWarnMinutes",
        "label": "md.fields.kds_warn_minutes",
        "required": false,
        "type": "number"
      },
      {
        "key": "kdsLateMinutes",
        "label": "md.fields.kds_late_minutes",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "storeId": null,
      "code": "",
      "name": "",
      "stationType": "",
      "primaryDeviceId": null,
      "fallbackDeviceId": null,
      "kdsEnabled": false,
      "kdsWarnMinutes": 8,
      "kdsLateMinutes": 12
    },
    "children": [
      "store.station_routing"
    ],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "stationType",
        "label": "md.fields.station_type",
        "type": "select",
        "options": [
          {
            "value": "kitchen",
            "label": "md.enums.station_type.kitchen"
          },
          {
            "value": "bar",
            "label": "md.enums.station_type.bar"
          },
          {
            "value": "pastry",
            "label": "md.enums.station_type.pastry"
          },
          {
            "value": "expo",
            "label": "md.enums.station_type.expo"
          },
          {
            "value": "other",
            "label": "md.enums.station_type.other"
          }
        ]
      },
      {
        "key": "primaryDeviceId",
        "label": "md.fields.primary_device_id",
        "type": "reference",
        "ref": "store.device"
      },
      {
        "key": "fallbackDeviceId",
        "label": "md.fields.fallback_device_id",
        "type": "reference",
        "ref": "store.device"
      },
      {
        "key": "kdsEnabled",
        "label": "md.fields.kds_enabled",
        "type": "toggle"
      }
    ],
    "route": "/pos/stations",
    "group": "pos",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.station_routing": {
    "key": "store.station_routing",
    "title": "md.resources.store_station_routing",
    "path": "/api/v1/devices/stations/{parentId}/routing",
    "readPermission": "ho.devices.stations.read",
    "writePermission": "ho.devices.stations.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "itemCategoryId",
        "type": "reference",
        "ref": "catalog.item_category",
        "header": "md.fields.item_category_id"
      },
      {
        "key": "priority",
        "type": "number",
        "header": "md.fields.priority"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "itemCategoryId",
        "label": "md.fields.item_category_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "required": false,
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.sale_type"
      },
      {
        "key": "priority",
        "label": "md.fields.priority",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "storeId": null,
      "itemCategoryId": null,
      "itemId": null,
      "saleTypeId": null,
      "priority": 0
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "itemCategoryId",
        "label": "md.fields.item_category_id",
        "type": "reference",
        "ref": "catalog.item_category"
      },
      {
        "key": "itemId",
        "label": "md.fields.item_id",
        "type": "reference",
        "ref": "catalog.item"
      },
      {
        "key": "saleTypeId",
        "label": "md.fields.sale_type_id",
        "type": "reference",
        "ref": "config.sale_type"
      }
    ],
    "parent": "store.station",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.table_area": {
    "key": "store.table_area",
    "title": "md.resources.store_table_area",
    "path": "/api/v1/tables/areas",
    "readPermission": "ho.tables.areas.read",
    "writePermission": "ho.tables.areas.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "chargeTypeId",
        "type": "reference",
        "ref": "config.charge_type",
        "header": "md.fields.charge_type_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "chargeTypeId",
        "label": "md.fields.charge_type_id",
        "required": false,
        "type": "reference",
        "ref": "config.charge_type"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "storeId": null,
      "code": "",
      "name": "",
      "chargeTypeId": null,
      "sortOrder": 0
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "chargeTypeId",
        "label": "md.fields.charge_type_id",
        "type": "reference",
        "ref": "config.charge_type"
      }
    ],
    "route": "/tables/areas",
    "group": "tables",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.floor_plan": {
    "key": "store.floor_plan",
    "title": "md.resources.store_floor_plan",
    "path": "/api/v1/tables/floor-plans",
    "readPermission": "ho.tables.floor_plans.read",
    "writePermission": "ho.tables.floor_plans.manage",
    "labelFields": [
      "name"
    ],
    "columns": [
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "canvasWidth",
        "label": "md.fields.canvas_width",
        "required": false,
        "type": "number"
      },
      {
        "key": "canvasHeight",
        "label": "md.fields.canvas_height",
        "required": false,
        "type": "number"
      },
      {
        "key": "backgroundUrl",
        "label": "md.fields.background_url",
        "required": false,
        "type": "text"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      }
    ],
    "empty": {
      "storeId": null,
      "name": "",
      "canvasWidth": 1600,
      "canvasHeight": 900,
      "backgroundUrl": null,
      "sortOrder": 0
    },
    "children": [
      "store.dining_table",
      "store.section_floor_plan"
    ],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      }
    ],
    "route": "/tables/floor-plans",
    "group": "tables",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.dining_table": {
    "key": "store.dining_table",
    "title": "md.resources.store_dining_table",
    "path": "/api/v1/tables/floor-plans/{parentId}/tables",
    "readPermission": "ho.tables.floor_plans.read",
    "writePermission": "ho.tables.floor_plans.manage",
    "labelFields": [
      "code"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "shape",
        "type": "select",
        "options": [
          {
            "value": "rect",
            "label": "md.enums.shape.rect"
          },
          {
            "value": "square",
            "label": "md.enums.shape.square"
          },
          {
            "value": "round",
            "label": "md.enums.shape.round"
          }
        ],
        "header": "md.fields.shape"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "tableAreaId",
        "type": "reference",
        "ref": "store.table_area",
        "header": "md.fields.table_area_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "tableAreaId",
        "label": "md.fields.table_area_id",
        "required": true,
        "type": "reference",
        "ref": "store.table_area"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "capacity",
        "label": "md.fields.capacity",
        "required": false,
        "type": "number"
      },
      {
        "key": "shape",
        "label": "md.fields.shape",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "rect",
            "label": "md.enums.shape.rect"
          },
          {
            "value": "square",
            "label": "md.enums.shape.square"
          },
          {
            "value": "round",
            "label": "md.enums.shape.round"
          }
        ]
      },
      {
        "key": "posX",
        "label": "md.fields.pos_x",
        "required": false,
        "type": "number"
      },
      {
        "key": "posY",
        "label": "md.fields.pos_y",
        "required": false,
        "type": "number"
      },
      {
        "key": "width",
        "label": "md.fields.width",
        "required": false,
        "type": "number"
      },
      {
        "key": "height",
        "label": "md.fields.height",
        "required": false,
        "type": "number"
      },
      {
        "key": "rotation",
        "label": "md.fields.rotation",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "storeId": null,
      "tableAreaId": null,
      "code": "",
      "capacity": 4,
      "shape": "rect",
      "posX": 0,
      "posY": 0,
      "width": 120,
      "height": 120,
      "rotation": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "tableAreaId",
        "label": "md.fields.table_area_id",
        "type": "reference",
        "ref": "store.table_area"
      },
      {
        "key": "shape",
        "label": "md.fields.shape",
        "type": "select",
        "options": [
          {
            "value": "rect",
            "label": "md.enums.shape.rect"
          },
          {
            "value": "square",
            "label": "md.enums.shape.square"
          },
          {
            "value": "round",
            "label": "md.enums.shape.round"
          }
        ]
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "parent": "store.floor_plan",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.section_floor_plan": {
    "key": "store.section_floor_plan",
    "title": "md.resources.store_section_floor_plan",
    "path": "/api/v1/tables/floor-plans/{parentId}/sections",
    "readPermission": "ho.tables.floor_plans.read",
    "writePermission": "ho.tables.floor_plans.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "posLayoutSectionId",
        "type": "reference",
        "ref": "config.pos_layout_section",
        "header": "md.fields.pos_layout_section_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posLayoutSectionId",
        "label": "md.fields.pos_layout_section_id",
        "required": true,
        "type": "reference",
        "ref": "config.pos_layout_section"
      }
    ],
    "empty": {
      "storeId": null,
      "posLayoutSectionId": null
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "posLayoutSectionId",
        "label": "md.fields.pos_layout_section_id",
        "type": "reference",
        "ref": "config.pos_layout_section"
      }
    ],
    "parent": "store.floor_plan",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.shift_definition": {
    "key": "store.shift_definition",
    "title": "md.resources.store_shift_definition",
    "path": "/api/v1/shifts/shift-definitions",
    "readPermission": "ho.shifts.shift_definitions.read",
    "writePermission": "ho.shifts.shift_definitions.manage",
    "labelFields": [
      "code",
      "name"
    ],
    "columns": [
      {
        "key": "code",
        "type": "text",
        "header": "md.fields.code"
      },
      {
        "key": "name",
        "type": "text",
        "header": "md.fields.name"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      },
      {
        "key": "isActive",
        "type": "toggle",
        "header": "md.fields.is_active"
      },
      {
        "key": "sortOrder",
        "type": "number",
        "header": "md.fields.sort_order"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "code",
        "label": "md.fields.code",
        "required": true,
        "type": "text"
      },
      {
        "key": "name",
        "label": "md.fields.name",
        "required": true,
        "type": "text"
      },
      {
        "key": "nameI18n",
        "label": "md.fields.name_i18n",
        "required": false,
        "type": "localized"
      },
      {
        "key": "startsAt",
        "label": "md.fields.starts_at",
        "required": true,
        "type": "time"
      },
      {
        "key": "endsAt",
        "label": "md.fields.ends_at",
        "required": true,
        "type": "time"
      },
      {
        "key": "daysOfWeek",
        "label": "md.fields.days_of_week",
        "required": false,
        "type": "weekdays"
      },
      {
        "key": "sortOrder",
        "label": "md.fields.sort_order",
        "required": false,
        "type": "number"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "required": false,
        "type": "toggle"
      }
    ],
    "empty": {
      "storeId": null,
      "code": "",
      "name": "",
      "nameI18n": {},
      "startsAt": null,
      "endsAt": null,
      "daysOfWeek": 127,
      "sortOrder": 0,
      "isActive": true
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "isActive",
        "label": "md.fields.is_active",
        "type": "toggle"
      }
    ],
    "route": "/pos/shift-definitions",
    "group": "pos",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "store.shift_settings": {
    "key": "store.shift_settings",
    "title": "md.resources.store_shift_settings",
    "path": "/api/v1/shifts/shift-settings",
    "readPermission": "ho.shifts.shift_settings.read",
    "writePermission": "ho.shifts.shift_settings.manage",
    "labelFields": [
      "id"
    ],
    "columns": [
      {
        "key": "requireMode",
        "type": "select",
        "options": [
          {
            "value": "required",
            "label": "md.enums.require_mode.required"
          },
          {
            "value": "optional",
            "label": "md.enums.require_mode.optional"
          },
          {
            "value": "off",
            "label": "md.enums.require_mode.off"
          }
        ],
        "header": "md.fields.require_mode"
      },
      {
        "key": "openMode",
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.open_mode.manual"
          },
          {
            "value": "auto",
            "label": "md.enums.open_mode.auto"
          }
        ],
        "header": "md.fields.open_mode"
      },
      {
        "key": "storeId",
        "type": "reference",
        "ref": "org.store",
        "header": "md.fields.store_id"
      }
    ],
    "fields": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "required": true,
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "requireMode",
        "label": "md.fields.require_mode",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "required",
            "label": "md.enums.require_mode.required"
          },
          {
            "value": "optional",
            "label": "md.enums.require_mode.optional"
          },
          {
            "value": "off",
            "label": "md.enums.require_mode.off"
          }
        ]
      },
      {
        "key": "openMode",
        "label": "md.fields.open_mode",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.open_mode.manual"
          },
          {
            "value": "auto",
            "label": "md.enums.open_mode.auto"
          }
        ]
      },
      {
        "key": "cashCountEnabled",
        "label": "md.fields.cash_count_enabled",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "countScope",
        "label": "md.fields.count_scope",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "store",
            "label": "md.enums.count_scope.store"
          },
          {
            "value": "terminal",
            "label": "md.enums.count_scope.terminal"
          }
        ]
      },
      {
        "key": "defaultOpeningFloat",
        "label": "md.fields.default_opening_float",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "varianceTolerance",
        "label": "md.fields.variance_tolerance",
        "required": false,
        "type": "decimal"
      },
      {
        "key": "blindCount",
        "label": "md.fields.blind_count",
        "required": false,
        "type": "toggle"
      },
      {
        "key": "attendanceMode",
        "label": "md.fields.attendance_mode",
        "required": false,
        "type": "select",
        "options": [
          {
            "value": "off",
            "label": "md.enums.attendance_mode.off"
          },
          {
            "value": "on_login",
            "label": "md.enums.attendance_mode.on_login"
          },
          {
            "value": "separate",
            "label": "md.enums.attendance_mode.separate"
          }
        ]
      }
    ],
    "empty": {
      "storeId": null,
      "requireMode": "optional",
      "openMode": "auto",
      "cashCountEnabled": true,
      "countScope": "store",
      "defaultOpeningFloat": 0.0,
      "varianceTolerance": 0.0,
      "blindCount": false,
      "attendanceMode": "off"
    },
    "children": [],
    "filters": [
      {
        "key": "storeId",
        "label": "md.fields.store_id",
        "type": "reference",
        "ref": "org.store"
      },
      {
        "key": "requireMode",
        "label": "md.fields.require_mode",
        "type": "select",
        "options": [
          {
            "value": "required",
            "label": "md.enums.require_mode.required"
          },
          {
            "value": "optional",
            "label": "md.enums.require_mode.optional"
          },
          {
            "value": "off",
            "label": "md.enums.require_mode.off"
          }
        ]
      },
      {
        "key": "openMode",
        "label": "md.fields.open_mode",
        "type": "select",
        "options": [
          {
            "value": "manual",
            "label": "md.enums.open_mode.manual"
          },
          {
            "value": "auto",
            "label": "md.enums.open_mode.auto"
          }
        ]
      },
      {
        "key": "cashCountEnabled",
        "label": "md.fields.cash_count_enabled",
        "type": "toggle"
      },
      {
        "key": "countScope",
        "label": "md.fields.count_scope",
        "type": "select",
        "options": [
          {
            "value": "store",
            "label": "md.enums.count_scope.store"
          },
          {
            "value": "terminal",
            "label": "md.enums.count_scope.terminal"
          }
        ]
      },
      {
        "key": "blindCount",
        "label": "md.fields.blind_count",
        "type": "toggle"
      },
      {
        "key": "attendanceMode",
        "label": "md.fields.attendance_mode",
        "type": "select",
        "options": [
          {
            "value": "off",
            "label": "md.enums.attendance_mode.off"
          },
          {
            "value": "on_login",
            "label": "md.enums.attendance_mode.on_login"
          },
          {
            "value": "separate",
            "label": "md.enums.attendance_mode.separate"
          }
        ]
      }
    ],
    "route": "/pos/shift-settings",
    "group": "pos",
    "fixedOnEdit": [
      "storeId"
    ]
  },
  "org.permission": {
    "key": "org.permission",
    "title": "md.resources.org_permission",
    "path": "/api/v1/identity/permissions",
    "readPermission": "ho.org.read",
    "writePermission": null,
    "labelFields": [
      "code",
      "description"
    ],
    "valueField": "code",
    "columns": [],
    "fields": [],
    "empty": {},
    "children": []
  },
  "config.pos_action": {
    "key": "config.pos_action",
    "title": "md.resources.config_pos_action",
    "path": "/api/v1/menu/config/pos-actions",
    "readPermission": "ho.config.read",
    "writePermission": null,
    "labelFields": [
      "code",
      "description"
    ],
    "valueField": "code",
    "columns": [],
    "fields": [],
    "empty": {},
    "children": []
  },
  "integration.provider_account": {
    "key": "integration.provider_account",
    "title": "md.resources.integration_provider_account",
    "path": "/api/v1/integration/einvoice/account-options",
    "readPermission": "ho.einvoice.read",
    "writePermission": null,
    "labelFields": [
      "name"
    ],
    "valueField": "id",
    "columns": [],
    "fields": [],
    "empty": {},
    "children": []
  }
} as const satisfies Record<string, ResourceDef>;

export const NAV_GROUPS = [
  {
    "group": "org",
    "label": "md.groups.org",
    "items": [
      "org.brand",
      "org.legal_entity",
      "org.store",
      "org.store_group",
      "org.app_user",
      "org.role"
    ]
  },
  {
    "group": "catalog",
    "label": "md.groups.catalog",
    "items": [
      "catalog.item",
      "catalog.item_group",
      "catalog.item_category",
      "catalog.modifier_group",
      "catalog.deal",
      "catalog.tax_category",
      "catalog.uom",
      "catalog.uom_conversion"
    ]
  },
  {
    "group": "menu",
    "label": "md.groups.menu",
    "items": [
      "menu.menu",
      "menu.menu_layout",
      "menu.price_list"
    ]
  },
  {
    "group": "pos",
    "label": "md.groups.pos",
    "items": [
      "config.sales_channel",
      "config.sale_type",
      "config.order_flow",
      "config.pos_layout",
      "config.pos_profile",
      "config.payment_method",
      "config.delivery_service",
      "config.charge_type",
      "config.discount_preset",
      "config.reason_code",
      "config.prompt",
      "config.document_template",
      "store.terminal",
      "store.device",
      "store.station",
      "store.shift_definition",
      "store.shift_settings"
    ]
  },
  {
    "group": "tables",
    "label": "md.groups.tables",
    "items": [
      "store.table_area",
      "store.floor_plan"
    ]
  },
  {
    "group": "geo",
    "label": "md.groups.geo",
    "items": [
      "geo.country",
      "geo.admin_division",
      "geo.postal_code"
    ]
  },
  {
    "group": "promotions",
    "label": "md.groups.promotions",
    "items": [
      "promotions.promotion",
      "membership.gift_voucher_batch"
    ]
  },
  {
    "group": "loyalty",
    "label": "md.groups.loyalty",
    "items": [
      "membership.member_club",
      "membership.member_scheme",
      "membership.member_account",
      "membership.member_contact",
      "membership.member_card",
      "membership.reward_program"
    ]
  },
  {
    "group": "marketing",
    "label": "md.groups.marketing",
    "items": [
      "crm.segment"
    ]
  },
  {
    "group": "cms",
    "label": "md.groups.cms",
    "items": [
      "cms.page"
    ]
  },
  {
    "group": "einvoice",
    "label": "md.groups.einvoice",
    "items": [
      "einvoice.einvoice_profile"
    ]
  },
  {
    "group": "online",
    "label": "md.groups.online",
    "items": [
      "config.brand_site",
      "config.delivery_fee_rule",
      "online.channel_store",
      "online.blocked_word"
    ]
  }
] as const;
